import { uuidv4 } from '@firebase/util'
import {
  faCheck,
  faEye,
  faSpinner,
  faTimes,
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { format } from 'date-fns'
import {
  Files,
  FilePdf,
  FloppyDisk,
  Info,
  MagnifyingGlass,
  Printer,
  ShieldCheck,
  Stamp,
  UploadSimple,
} from 'phosphor-react'
import React, { useEffect, useState, useRef } from 'react'
import {
  Alert,
  Button,
  Card,
  CardBody,
  Col,
  Form,
  Modal,
  Row,
  Table,
} from 'react-bootstrap'
import { FaEdit, FaTrash } from 'react-icons/fa'
import {
  default as InputMask,
  default as ReactInputMask,
} from 'react-input-mask'
import { useNavigate, useParams } from 'react-router-dom'
import { toast } from 'react-toastify'
import Swal from 'sweetalert2'
import { ContentLoading } from '../../components/ContentLoading/index.js'
import { CustomButton } from '../../components/CustomButton/index.jsx'
import Navbar from '../../components/navbar/navbar.jsx'
import apidfe from '../../services/apidfe'
import apinode from '../../services/apinode'
import { sendErrorApiMessage } from '../../utils/sendErrorApiMessage.js'
import pdfMake from 'pdfmake/build/pdfmake'
import pdfFonts from 'pdfmake/build/vfs_fonts'
import styled, { createGlobalStyle, keyframes } from 'styled-components'

pdfMake.addVirtualFileSystem(pdfFonts)

// ─── Global styles ────────────────────────────────────────────────────────────
const GlobalStyle = createGlobalStyle`
  body { font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif !important; background: #f0f2f5 !important; }

  .nfe-label {
    display: block;
    font-size: 11px;
    font-weight: 600;
    letter-spacing: 0.3px;
    color: #52525b;
    margin-bottom: 4px;
  }

  .nfe-input {
    height: 34px !important;
    border: 1px solid #d4d4d8 !important;
    border-radius: 6px !important;
    font-size: 13px !important;
    font-family: inherit !important;
    color: #18181b !important;
    background: #fff !important;
    transition: border-color 0.15s, box-shadow 0.15s !important;
    padding: 0 10px !important;
    width: 100% !important;
  }
  .nfe-input:focus {
    border-color: #3b82f6 !important;
    box-shadow: 0 0 0 3px rgba(59,130,246,0.12) !important;
    outline: none !important;
  }
  .nfe-input:disabled {
    background: #f4f4f5 !important;
    color: #a1a1aa !important;
    cursor: default !important;
  }
  .nfe-select {
    height: 34px !important;
    border: 1px solid #d4d4d8 !important;
    border-radius: 6px !important;
    font-size: 13px !important;
    font-family: inherit !important;
    color: #18181b !important;
    background: #fff !important;
    transition: border-color 0.15s !important;
    padding: 0 10px !important;
    width: 100% !important;
    cursor: pointer !important;
  }
  .nfe-select:focus {
    border-color: #3b82f6 !important;
    box-shadow: 0 0 0 3px rgba(59,130,246,0.12) !important;
    outline: none !important;
  }
  .nfe-textarea {
    border: 1px solid #d4d4d8 !important;
    border-radius: 6px !important;
    font-size: 12px !important;
    font-family: inherit !important;
    resize: vertical !important;
    transition: border-color 0.15s !important;
    width: 100% !important;
    padding: 8px 10px !important;
  }
  .nfe-textarea:focus {
    border-color: #3b82f6 !important;
    box-shadow: 0 0 0 3px rgba(59,130,246,0.12) !important;
    outline: none !important;
  }
`

// ─── Styled components ────────────────────────────────────────────────────────
const PageWrap = styled.div`
  background: #f0f2f5;
  min-height: 100vh;
  width: 100%;
  padding-bottom: 80px;
`

const PageHeader = styled.div`
  background: #fff;
  padding: 14px 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #e4e4e7;
  position: sticky;
  top: 0;
  z-index: 100;

  h1 {
    font-size: 16px;
    font-weight: 600;
    color: #18181b;
    margin: 0;
  }
`
const SectionCard = styled.div`
  background: #fff;
  border: 1px solid #e4e4e7;
  border-radius: 8px;
  margin-bottom: 12px;
  overflow: visible; // ← era hidden, mude para visible
`

const SectionHeader = styled.div`
  background: #fafafa;
  border-bottom: 1px solid #e4e4e7;
  padding: 8px 16px;
  display: flex;
  align-items: center;
  gap: 8px;

  span.badge-section {
    background: #3b82f6;
    color: #fff;
    font-size: 9px;
    font-weight: 700;
    letter-spacing: 0.8px;
    text-transform: uppercase;
    padding: 2px 7px;
    border-radius: 20px;
  }

  h3 {
    font-size: 11px;
    font-weight: 600;
    color: #52525b;
    margin: 0;
    letter-spacing: 0.3px;
    text-transform: uppercase;
  }
`

const SectionBody = styled.div`
  padding: 16px;
`

const ChaveRefBanner = styled.div`
  background: #eff6ff;
  border: 1px solid #bfdbfe;
  border-radius: 7px;
  padding: 10px 14px;
  margin-top: 12px;
  display: flex;
  align-items: center;
  gap: 10px;

  .icon {
    font-size: 18px;
    flex-shrink: 0;
  }

  .info {
    flex: 1;
  }
  .info strong {
    font-size: 11px;
    font-weight: 600;
    color: #1d4ed8;
    display: block;
    margin-bottom: 1px;
  }
  .info span {
    font-size: 11px;
    color: #71717a;
  }

  input {
    flex: 1;
    height: 32px;
    border: 1px solid #bfdbfe;
    border-radius: 6px;
    font-size: 12px;
    font-family: 'Courier New', monospace;
    color: #1e40af;
    background: #fff;
    padding: 0 10px;
    letter-spacing: 0.5px;
    transition: border-color 0.15s;
    min-width: 0;
  }
  input:focus {
    border-color: #3b82f6;
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.12);
    outline: none;
  }
  input::placeholder {
    color: #93c5fd;
    letter-spacing: 0;
    font-family: inherit;
  }
`

const StatusBadge = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-size: 11px;
  font-weight: 600;
  padding: 4px 12px;
  border-radius: 20px;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  ${({ $s }) =>
    $s === 'T' && `background:#dcfce7;color:#166534;border:1px solid #86efac;`}
  ${({ $s }) =>
    $s === 'R' && `background:#fee2e2;color:#991b1b;border:1px solid #fca5a5;`}
  ${({ $s }) =>
    $s === 'D' && `background:#dbeafe;color:#1e40af;border:1px solid #93c5fd;`}
  ${({ $s }) =>
    $s === 'C' && `background:#fef9c3;color:#854d0e;border:1px solid #fde047;`}
  ${({ $s }) =>
    !['T', 'R', 'D', 'C'].includes($s) &&
    `background:#f4f4f5;color:#52525b;border:1px solid #d4d4d8;`}
`

const ActionBar = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: #fff;
  border-top: 1px solid #e4e4e7;
  padding: 10px 24px;
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  align-items: center;
  z-index: 200;
  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.06);
`

const ItemTable = styled.div`
  overflow-x: auto;
  border-radius: 6px;
  border: 1px solid #e4e4e7;

  table {
    width: 100%;
    border-collapse: collapse;
    font-size: 11px;
    font-family: 'Courier New', monospace;
    min-width: 1400px;

    thead tr {
      background: #f4f4f5;
    }
    thead th {
      padding: 7px 10px;
      font-size: 9px;
      font-weight: 700;
      letter-spacing: 0.7px;
      text-transform: uppercase;
      border: none;
      white-space: nowrap;
      color: #52525b;
      border-bottom: 1px solid #e4e4e7;
    }
    tbody tr:nth-child(even) {
      background: #fafafa;
    }
    tbody tr:hover {
      background: #eff6ff;
    }
    tbody td {
      padding: 5px 10px;
      border-bottom: 1px solid #f4f4f5;
      color: #3f3f46;
      white-space: nowrap;
    }
  }
`

const TableActionsRow = styled.div`
  display: flex;
  gap: 8px;
  margin-top: 10px;
  flex-wrap: wrap;
`

const BtnCalc = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 14px;
  border: none;
  border-radius: 6px;
  font-family: inherit;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition:
    opacity 0.15s,
    transform 0.1s;
  &:active {
    transform: scale(0.98);
  }

  &.blue {
    background: #3b82f6;
    color: #fff;
  }
  &.green {
    background: #22c55e;
    color: #fff;
  }
  &.blue:hover {
    background: #2563eb;
  }
  &.green:hover {
    background: #16a34a;
  }
`

// ─── NCMs com Substituição Tributária em SP ──────────────────────────────────
const NCM_COM_ST = new Set([
  '94051190',
  '94052900',
  '94051910',
  '94051990',
  '94052100',
  '94052990',
  '94054010',
  '94054090',
  '94055000',
  '94056000',
  '94059100',
  '94059900',
  '85395000',
  '85392110',
  '85392190',
  '85392210',
  '85392290',
  '85393110',
  '85393190',
  '85393210',
  '85393290',
  '85393910',
  '85393990',
  '85394100',
  '85399000',
  '85369030',
  '85366990',
  '85362010',
  '85362090',
  '85363010',
  '85363090',
  '85364110',
  '85364190',
  '85365010',
  '85365090',
  '85371010',
  '85371090',
  '85372010',
  '85372090',
  '85389000',
  '85360010',
  '85360090',
  '85444900',
  '85446000',
  '85447000',
  '96039000',
  '96031000',
  '96032100',
  '96032900',
  '96033000',
  '96034000',
  '96039010',
  '96039090',
  '32081010',
  '32081090',
  '32082010',
  '32082090',
  '32089010',
  '32089090',
  '32091010',
  '32091090',
  '32099010',
  '32099090',
  '32100010',
  '32100090',
  '32110000',
  '32121000',
  '32129000',
  '32131000',
  '32139000',
  '32141000',
  '32149000',
  '87082110',
  '87082190',
  '87083010',
  '87083090',
  '87084010',
  '87084090',
  '87085010',
  '87085090',
  '87086010',
  '87086090',
  '87087010',
  '87087090',
  '87088010',
  '87088090',
  '87089110',
  '87089190',
  '87089911',
  '87089919',
  '87089991',
  '87089992',
  '87089999',
  '87089990',
  '82041100',
  '82041200',
  '82042000',
  '82051000',
  '82052000',
  '82053000',
  '82054000',
  '82055100',
  '82055900',
  '82059000',
  '82060000',
  '82071300',
  '82071900',
  '82072000',
  '82073000',
  '82074000',
  '82075000',
  '82076000',
  '82079000',
  '82081000',
  '82082000',
  '82083000',
  '82084000',
  '82089000',
  '82090000',
  '82100000',
  '82121000',
  '82122000',
  '82130000',
  '82141000',
  '82142000',
  '82149000',
  '82151000',
  '82152000',
  '82159100',
  '82159900',
  '33030010',
  '33030020',
  '33030090',
  '33041000',
  '33042000',
  '33043000',
  '33049100',
  '33049910',
  '33049990',
  '33051000',
  '33052000',
  '33053000',
  '33059000',
  '33061000',
  '33062000',
  '33069000',
  '33071000',
  '33072000',
  '33073000',
  '33074100',
  '33074900',
  '33079000',
  '40111000',
  '40112000',
  '40113000',
  '40114000',
  '40115000',
  '40116010',
  '40116090',
  '40119200',
  '40119300',
  '40119900',
  '40121100',
  '40121200',
  '40121300',
  '40121900',
  '40130000',
  '22021000',
  '22029000',
  '22030000',
  '22041000',
  '22042100',
  '22042900',
  '22043000',
  '22051000',
  '22060000',
  '22071000',
  '22072000',
  '22082000',
  '22083000',
  '22084000',
  '22085000',
  '22086000',
  '22087000',
  '22089000',
  '24011000',
  '24012000',
  '24013000',
  '24021000',
  '24022000',
  '24029000',
  '24031100',
  '24031900',
  '24039100',
  '24039900',
  '21050000',
  '19013700',
  '21069030',
  '30031000',
  '30032000',
  '30033100',
  '30033900',
  '30034100',
  '30034200',
  '30039000',
  '30041000',
  '30042000',
  '30043100',
  '30043900',
  '30044100',
  '30049000',
  '30051000',
  '30059000',
  '23091000',
  '23099000',
  '48181000',
  '48182000',
  '48183000',
  '48184000',
  '48189000',
  '84713000',
  '84714100',
  '84714900',
  '84715000',
  '84716000',
  '84717000',
  '84718000',
  '84719000',
  '84733000',
  '85171200',
  '85176200',
  '85258011',
  '85258019',
  '85258021',
  '85258029',
  '85271200',
  '85271300',
  '85282111',
  '85282119',
  '85287200',
  '39174000',
  '39269090',
  '39241000',
  '39249000',
  '39251000',
  '39252000',
  '39253000',
  '39259000',
  '39261000',
  '39262000',
  '39263000',
  '39264000',
  '39269010',
  '39269020',
  '39269030',
  '39269040',
  '39269050',
  '70139000',
  '70141000',
  '70151000',
  '70159000',
  '70161000',
  '70169000',
  '70172000',
  '70179000',
  '69010000',
  '69021000',
  '69022000',
  '69029000',
  '69031000',
  '69032000',
  '69039000',
  '69041000',
  '69049000',
  '69051000',
  '69059000',
  '69060000',
  '69072100',
  '69072200',
  '69072300',
  '69072900',
  '69073000',
  '69074000',
  '69079000',
  '69089000',
  '25231000',
  '25232100',
  '25232900',
  '25233000',
  '25239000',
  '72081000',
  '72082500',
  '72082600',
  '72082700',
  '72083600',
  '72083700',
  '72083800',
  '72083900',
  '72084000',
  '72085100',
  '72085200',
  '72085300',
  '72085400',
  '72089000',
  '72091500',
  '72091600',
  '72091700',
  '72091800',
  '72092500',
  '72092600',
  '72092700',
  '72092800',
  '72099000',
  '72101100',
  '72101200',
  '72102000',
  '72103000',
  '72104100',
  '72104900',
  '72105000',
  '72106100',
  '72106900',
  '72107000',
  '72109000',
  '72111300',
  '72111400',
  '72111900',
  '72112300',
  '72112900',
  '72113000',
  '72119000',
  '72121000',
  '72122000',
  '72123000',
  '72124000',
  '72125000',
  '72126000',
  '72131000',
  '72132000',
  '72139100',
  '72139900',
  '72141000',
  '72142000',
  '72149100',
  '72149900',
  '72151000',
  '72155000',
  '72159000',
  '72161000',
  '72162100',
  '72162200',
  '72163100',
  '72163200',
  '72163300',
  '72164000',
  '72165000',
  '72166000',
  '72169100',
  '72169900',
  '40151100',
  '40151900',
  '40159000',
  '40161000',
  '40162000',
  '40163000',
  '40164000',
  '40165100',
  '40165200',
  '40165300',
  '40165900',
  '40169100',
  '40169200',
  '40169300',
  '40169400',
  '40169500',
  '40169900',
  '87120010',
  '87120090',
  '87141000',
  '87142000',
  '87143000',
  '87144000',
  '87149100',
  '87149200',
  '87149300',
  '87149400',
  '87149900',
  '94011000',
  '94012000',
  '94013000',
  '94014000',
  '94015000',
  '94016100',
  '94016900',
  '94017100',
  '94017900',
  '94018000',
  '94019000',
  '94041000',
  '94042000',
  '94043000',
  '94049000',
  '84501100',
  '84501200',
  '84501900',
  '84502000',
  '84509000',
  '84511000',
  '84512000',
  '84513000',
  '84514000',
  '84515000',
  '84516000',
  '84519000',
  '84521000',
  '84522100',
  '84522900',
  '84523000',
  '84529000',
  '84531000',
  '84532000',
  '84539000',
  '84151000',
  '84152000',
  '84158100',
  '84158200',
  '84158300',
  '84159000',
  '73211100',
  '73211200',
  '73211300',
  '73211900',
  '73212000',
  '73213000',
  '73219000',
  '84141000',
  '84142000',
  '84143000',
  '84144000',
  '84145100',
  '84145900',
  '84146000',
  '84149000',
  '17011310',
  '17011390',
  '17011410',
  '17011490',
  '17019900',
  '15091000',
  '15099000',
  '15111000',
  '15119000',
  '15121100',
  '15121900',
  '15122100',
  '15122900',
  '15131100',
  '15131900',
  '15132100',
  '15132900',
  '15141100',
  '15141900',
  '15142100',
  '15142900',
  '04012000',
  '04013000',
  '04021000',
  '04022100',
  '04022900',
  '04031000',
  '04039000',
  '04041000',
  '04049000',
  '04051000',
  '04052000',
  '04059000',
  '04061000',
  '04062000',
  '04063000',
  '04064000',
  '04069000',
])

const getAliquotaInterestadual = (ufDestino) => {
  const sete = [
    'AC',
    'AL',
    'AM',
    'AP',
    'BA',
    'CE',
    'ES',
    'GO',
    'MA',
    'MS',
    'MT',
    'PA',
    'PB',
    'PE',
    'PI',
    'RN',
    'RO',
    'RR',
    'SE',
    'TO',
  ]
  return sete.includes(ufDestino) ? 7 : 12
}

const getCfopPorNatureza = (naturezaId, ncm, ufDestino, regimeEmpresa) => {
  const temST = NCM_COM_ST.has(ncm)
  const interestadual = ufDestino && ufDestino.toUpperCase() !== 'SP'
  switch (String(naturezaId)) {
    case '110':
    case '116':
    case '118':
      return temST ? '5405' : '5102'
    case '117':
    case '119':
      return temST ? '6404' : '6102'
    case '111':
    case '115':
      return interestadual ? '2202' : '1202'
    case '113':
      return interestadual ? '6915' : '5915'
    case '120':
    case '114':
      return interestadual ? '6949' : '5949'
    case '112':
      return interestadual ? '6910' : '5910'
    default:
      return interestadual ? '6102' : '5102'
  }
}

const getCstPorNatureza = (naturezaId, ncm, regimeEmpresa) => {
  const temST = NCM_COM_ST.has(ncm)
  const devolucao = ['111', '115'].includes(String(naturezaId))
  const remessa = ['113', '120'].includes(String(naturezaId))
  if (regimeEmpresa === 1) {
    if (devolucao || remessa) return { csosn: '27', csticms: '' }
    return temST ? { csosn: '28', csticms: '4' } : { csosn: '27', csticms: '' }
  }
  if (regimeEmpresa === 3) {
    if (devolucao || remessa) return { csosn: '', csticms: '17' }
    return temST
      ? { csosn: '28', csticms: '20' }
      : { csosn: '28', csticms: '4' }
  }
  return { csosn: '28', csticms: '4' }
}

const getAplicaDifal = (regime, ufDest, tipoPessoa, tipoContribuinte) => {
  if (regime !== 3) return false
  if ((ufDest || '').toUpperCase() === 'SP') return false
  const isPF = (tipoPessoa || '').toUpperCase() === 'F'
  const isNaoContribuinte = ['9', '99', '2'].includes(
    String(tipoContribuinte || '99'),
  )
  return isPF || isNaoContribuinte
}

// ─── NATUREZAS que exigem NF-e referenciada ───────────────────────────────────
const NATUREZAS_COM_REF = ['111', '115'] // devolução

// ─── Componente principal ─────────────────────────────────────────────────────
const EdicaoNFe = () => {
  const navigate = useNavigate()
  const { idnfe } = useParams()
  const TYPING_TIMEOUT = 1000

  const [destinatarioValue, setDestinatarioValue] = useState('')
  const [loading, setLoading] = useState(true)
  const [isGravarNfeLoading, setIsGravarNfeLoading] = useState(false)
  const [numeroNFe, setNumeroNFe] = useState('')
  const [serie, setSerie] = useState('')
  const [natureza, setNatureza] = useState('')
  const [datavenda, setDataVenda] = useState('')
  const [cep, setCep] = useState('')
  const [logradouro, setLogradouro] = useState('')
  const [pesNum, setPesNum] = useState('')
  const [pesBairro, setPEsBairro] = useState('')
  const [pesCidade, setPesCidade] = useState('')
  const [codIbge, setIbge] = useState('')
  const [uf, setUf] = useState('')
  const [showAddressModal, setShowAddressModal] = useState(false)
  const [nfeItens, setNfeItens] = useState([])
  const [showModal, setShowModal] = useState(false)
  const [editedItem, setEditedItem] = useState(null)
  const [searchResults, setSearchResults] = useState([])
  const [id_cliente, setIdCliente] = useState([])
  const [totalnfe, setTotalnfe] = useState(0)
  const [frete, setFrete] = useState(0)
  const [idtransp, setIdTransp] = useState(null)
  const [cnpjTransp, setCnpjTransp] = useState('')
  const [nomeTransp, setNomeTransp] = useState('')
  const [pesol, setPesol] = useState('')
  const [volume, setVolume] = useState('')
  const [pesob, setPesob] = useState('')
  const [typingTimeout, setTypingTimeout] = useState(null)
  const [emp_conta, setEmpConta] = useState('')
  const [searchResultsProd, setSearchResultsProd] = useState([])
  const [showModalTrans, setShowModalTrans] = useState(false)
  const [transmitting, setTransmitting] = useState(false)
  const [responseMessage, setResponseMessage] = useState('')
  const [tipo, setTipo] = useState('S')
  const [erro, setErro] = useState('')
  const [status, setStatus] = useState('')
  const [searchResultsTrans, setSearchResultsTrans] = useState([])
  const [observacaoInterna, setObservacaoInterna] = useState('')
  const [parcelas, setParcelas] = useState([])
  const [diasParcelas, setDiasParcelas] = useState('')
  const [resultado, setResultado] = useState([])
  const [tipoFrete, setTipoFrete] = useState('')
  const [chave, setChave] = useState('')
  const [linknfe, setLink] = useState('')
  const [reload, setReload] = useState(false)
  const [isConsultarLoading, setIsConsultarLoading] = useState(false)
  const [isEnviarDadosLoading, setIsEnviarDadosLoading] = useState(false)
  const [statusConsultar, setStatusConsultar] = useState()
  const [showResults, setShowResults] = useState(false)
  const [isConsultarSefazLoading, setIsConsultarSefazLoading] = useState(false)
  const [isProtocolarLoading, setIsProtocolarLoading] = useState(false)
  const [sefazCstat, setSefazCstat] = useState(null)
  const [cfopSearch, setCfopSearch] = useState('')
  const [showCfopDropdown, setShowCfopDropdown] = useState(false)
  const [regime, setRegime] = useState(null)
  const [endereco, setEndereco] = useState({
    pes_logradouro: '',
    pes_numero: '',
    pes_cidade: '',
    pes_uf: '',
    pes_cep: '',
    pes_telefone: '',
    pes_celular: '',
    pes_tipo: 'F',
    pes_razao: '',
    pes_cnpj_cpf: '',
    cod_tipo_contribuinte: '99',
    pes_bairro: '',
    pes_ibge: '',
    pes_insc_estadual: '',
  })
  const [emissaoSteps, setEmissaoSteps] = useState([])
  const [emissaoAtual, setEmissaoAtual] = useState(null)
  const transpInputRef = useRef(null)
  const [transpRect, setTranspRect] = useState(null)
  const [isSearchingProd, setIsSearchingProd] = useState(false)

  // ── NOVO: chave da NF-e referenciada (devolução / complementar) ──
  const [chaveRef, setChaveRef] = useState('')

  const addStep = (id, label, status = 'loading') => {
    setEmissaoSteps((prev) => {
      const exists = prev.find((s) => s.id === id)
      if (exists)
        return prev.map((s) => (s.id === id ? { ...s, status, label } : s))
      return [...prev, { id, label, status, ts: new Date() }]
    })
    setEmissaoAtual(status === 'loading' ? id : null)
  }

  const updateStep = (id, status, detail = '') => {
    setEmissaoSteps((prev) =>
      prev.map((s) => (s.id === id ? { ...s, status, detail } : s)),
    )
    setEmissaoAtual(null)
  }

  const [tipoDestinatario, setTipoDestinatario] = useState('F')
  const [tipoContribuinteDestinatario, setTipoContribuinteDestinatario] =
    useState('9')

  const CFOP_OPTIONS = [
    {
      codigo: '5101',
      descricao: 'Venda de produção do estabelecimento',
      tipo: 'Saída Estadual',
    },
    {
      codigo: '5102',
      descricao: 'Venda de mercadoria adquirida ou recebida de terceiros',
      tipo: 'Saída Estadual',
    },
    {
      codigo: '5103',
      descricao: 'Venda de produção efetuada fora do estabelecimento',
      tipo: 'Saída Estadual',
    },
    {
      codigo: '5104',
      descricao: 'Venda de mercadoria adquirida fora do estabelecimento',
      tipo: 'Saída Estadual',
    },
    {
      codigo: '5110',
      descricao: 'Venda destinada à Zona Franca de Manaus (produção)',
      tipo: 'Saída Estadual',
    },
    {
      codigo: '5111',
      descricao: 'Venda destinada à Zona Franca de Manaus (mercadoria)',
      tipo: 'Saída Estadual',
    },
    {
      codigo: '5405',
      descricao:
        'Venda de mercadoria sujeita ao regime de substituição tributária',
      tipo: 'Saída Estadual',
    },
    {
      codigo: '5910',
      descricao: 'Remessa em bonificação, doação ou brinde',
      tipo: 'Saída Estadual',
    },
    {
      codigo: '5915',
      descricao: 'Remessa de mercadoria para conserto ou reparo',
      tipo: 'Saída Estadual',
    },
    {
      codigo: '5949',
      descricao: 'Outra saída de mercadoria não especificada',
      tipo: 'Saída Estadual',
    },
    {
      codigo: '6101',
      descricao: 'Venda de produção do estabelecimento',
      tipo: 'Saída Interestadual',
    },
    {
      codigo: '6102',
      descricao: 'Venda de mercadoria adquirida ou recebida de terceiros',
      tipo: 'Saída Interestadual',
    },
    {
      codigo: '6103',
      descricao: 'Venda de produção efetuada fora do estabelecimento',
      tipo: 'Saída Interestadual',
    },
    {
      codigo: '6104',
      descricao: 'Venda de mercadoria adquirida fora do estabelecimento',
      tipo: 'Saída Interestadual',
    },
    {
      codigo: '6107',
      descricao: 'Venda destinada à Zona Franca de Manaus (produção)',
      tipo: 'Saída Interestadual',
    },
    {
      codigo: '6108',
      descricao: 'Venda destinada à Zona Franca de Manaus (mercadoria)',
      tipo: 'Saída Interestadual',
    },
    {
      codigo: '6404',
      descricao:
        'Venda de mercadoria sujeita ao regime de substituição tributária',
      tipo: 'Saída Interestadual',
    },
    {
      codigo: '6910',
      descricao: 'Remessa em bonificação, doação ou brinde',
      tipo: 'Saída Interestadual',
    },
    {
      codigo: '6915',
      descricao: 'Remessa de mercadoria para conserto ou reparo',
      tipo: 'Saída Interestadual',
    },
    {
      codigo: '6949',
      descricao: 'Outra saída de mercadoria não especificada',
      tipo: 'Saída Interestadual',
    },
    {
      codigo: '1101',
      descricao: 'Compra para industrialização',
      tipo: 'Entrada Estadual',
    },
    {
      codigo: '1102',
      descricao: 'Compra para comercialização',
      tipo: 'Entrada Estadual',
    },
    {
      codigo: '1202',
      descricao: 'Devolução de venda de mercadoria adquirida de terceiros',
      tipo: 'Entrada Estadual',
    },
    {
      codigo: '1411',
      descricao: 'Devolução de venda sujeita a substituição tributária',
      tipo: 'Entrada Estadual',
    },
    {
      codigo: '1556',
      descricao: 'Compra de material para uso ou consumo',
      tipo: 'Entrada Estadual',
    },
    {
      codigo: '2101',
      descricao: 'Compra para industrialização',
      tipo: 'Entrada Interestadual',
    },
    {
      codigo: '2102',
      descricao: 'Compra para comercialização',
      tipo: 'Entrada Interestadual',
    },
    {
      codigo: '2202',
      descricao: 'Devolução de venda de mercadoria adquirida de terceiros',
      tipo: 'Entrada Interestadual',
    },
    {
      codigo: '2411',
      descricao: 'Devolução de venda sujeita a substituição tributária',
      tipo: 'Entrada Interestadual',
    },
    {
      codigo: '2556',
      descricao: 'Compra de material para uso ou consumo',
      tipo: 'Entrada Interestadual',
    },
  ]

  const CST_CSOSN_OPTIONS = [
    { id: 4, descricao: 'Tributada integralmente', codigo: '00', tipo: 'CST' },
    { id: 5, descricao: 'Isenta', codigo: '40', tipo: 'CST' },
    {
      id: 14,
      descricao: 'Tributada e com cobrança do ICMS por substituição tributária',
      codigo: '10',
      tipo: 'CST',
    },
    { id: 15, descricao: 'Com redução da BC', codigo: '20', tipo: 'CST' },
    {
      id: 16,
      descricao: 'Isenta/não tributada e com cobrança do ICMS por ST',
      codigo: '30',
      tipo: 'CST',
    },
    { id: 17, descricao: 'Não tributada', codigo: '41', tipo: 'CST' },
    { id: 18, descricao: 'Com suspensão', codigo: '50', tipo: 'CST' },
    { id: 19, descricao: 'Com diferimento', codigo: '51', tipo: 'CST' },
    {
      id: 20,
      descricao: 'ICMS cobrado anteriormente por substituição tributária',
      codigo: '60',
      tipo: 'CST',
    },
    {
      id: 21,
      descricao: 'Com redução da BC e cobrança do ICMS por ST',
      codigo: '70',
      tipo: 'CST',
    },
    { id: 22, descricao: 'Outras', codigo: '90', tipo: 'CST' },
    {
      id: 6,
      descricao: 'Tributada pelo Simples Nacional com permissão de crédito',
      codigo: '101',
      tipo: 'CSOSN',
    },
    {
      id: 7,
      descricao: 'Tributada pelo Simples Nacional sem permissão de crédito',
      codigo: '102',
      tipo: 'CSOSN',
    },
    {
      id: 8,
      descricao:
        'Isenção do ICMS no Simples Nacional para faixa de receita bruta',
      codigo: '103',
      tipo: 'CSOSN',
    },
    {
      id: 23,
      descricao:
        'Trib. SN com permissão de crédito e com cobrança do ICMS por ST',
      codigo: '201',
      tipo: 'CSOSN',
    },
    {
      id: 24,
      descricao:
        'Trib. SN sem permissão de crédito e com cobrança do ICMS por ST',
      codigo: '202',
      tipo: 'CSOSN',
    },
    {
      id: 25,
      descricao:
        'Isenção do ICMS no SN para faixa de receita bruta e com cobrança do ICMS por ST',
      codigo: '203',
      tipo: 'CSOSN',
    },
    { id: 26, descricao: 'Imune', codigo: '300', tipo: 'CSOSN' },
    {
      id: 27,
      descricao: 'Não tributada pelo Simples Nacional',
      codigo: '400',
      tipo: 'CSOSN',
    },
    {
      id: 28,
      descricao:
        'ICMS cobrado anteriormente por ST (substituído) ou por antecipação',
      codigo: '500',
      tipo: 'CSOSN',
    },
    { id: 29, descricao: 'Outros', codigo: '900', tipo: 'CSOSN' },
  ]

  // ─── Helpers ───────────────────────────────────────────────────────────────
  const handleExcluirParcela = (n) =>
    setParcelas(parcelas.filter((p) => p.codigo !== n))
  const handeleditarValor = (n, v) =>
    setParcelas(
      parcelas.map((p) => (p.num_parcela === n ? { ...p, valor: v } : p)),
    )
  const handleEditarObservacao = (n, v) =>
    setResultado(parcelas.map((p) => (p.numero === n ? { ...p, obs: v } : p)))

  const calcularParcelas = () => {
    const vl = parseFloat(totalnfe)
    if (isNaN(vl)) return
    const dias = diasParcelas.split(',').map((d) => parseInt(d.trim()))
    if (dias.some(isNaN) || dias.some((d) => d <= 0)) return
    const dt = new Date(datavenda)
    if (isNaN(dt.getTime())) return
    setParcelas(
      dias.map((d, i) => {
        const venc = new Date(dt)
        venc.setDate(venc.getDate() + d)
        return {
          num_parcela: i + 1,
          data: `${venc}`,
          valor: (vl / dias.length).toFixed(2),
          obs: '',
        }
      }),
    )
  }

  // ─── Gravar NF-e ──────────────────────────────────────────────────────────
  async function handleGravarNFe() {
    const dadosNfe = {
      codcliente: id_cliente,
      itens: nfeItens,
      natureza,
      datavenda,
      volume,
      pesob,
      pesol,
      idtransportadora: idtransp,
      totalpedido: totalnfe,
      emp_conta,
      tipo,
      complemento: observacaoInterna,
      parcelas,
      frete: tipoFrete,
      valorfrete: frete,
      chave_ref: chaveRef, // ← envia a chave referenciada
    }
    try {
      setIsGravarNfeLoading(true)
      if (idnfe === 'novo') {
        const r = await apinode.post(
          `/nfe/inserir/${localStorage.idconta}`,
          dadosNfe,
        )
        toast.success('Cadastro realizado com sucesso!')
        navigate(`/nfe/editar/${r.data.idnfe}`)
      } else {
        await apinode.put(`nfe/${idnfe}/${localStorage.idconta}`, dadosNfe)
        await fetchNfe(true)
        toast.success('Alterações realizadas com sucesso!')
      }
    } catch (err) {
      sendErrorApiMessage(err, 'Erro ao gravar nota fiscal')
    } finally {
      setIsGravarNfeLoading(false)
    }
  }

  const getStatusLabel = (s) => {
    const map = {
      T: 'Transmitida',
      R: 'Erro',
      D: 'Em Digitação',
      C: 'Cancelada',
    }
    return <StatusBadge $s={s}>{map[s] || 'Desconhecido'}</StatusBadge>
  }

  // ─── Destinatário ──────────────────────────────────────────────────────────
  const handleSearchDestinatario = async (v) => {
    try {
      const r = await apinode.get(`/nfe/listapessoa/${localStorage.idconta}`, {
        params: { dados: v },
      })
      setSearchResults(r.data)
    } catch (e) {
      console.error(e)
    }
  }

  const handleInputChangeDestinatario = (e) => {
    const v = e.target.value
    setDestinatarioValue(v)
    if (v.length >= 3) {
      setLoading(true)
      handleSearchDestinatario(v)
    } else setSearchResults([])
  }

  const handleSelectDestinatario = (result) => {
    setDestinatarioValue(result.pes_razao)
    setIdCliente(result.cod_pessoa)
    setLogradouro(result.pes_logradouro)
    setPesNum(result.pes_numero)
    setPesCidade(result.pes_cidade)
    setPEsBairro(result.pes_bairro)
    setIbge(result.pes_ibge)
    setUf(result.pes_uf)
    setCep(result.pes_cep)
    setEndereco({
      pes_razao: result.pes_razao,
      pes_logradouro: result.pes_logradouro,
      pes_numero: result.pes_numero,
      pes_cidade: result.pes_cidade,
      pes_bairro: result.pes_bairro,
      pes_ibge: result.pes_ibge,
      pes_uf: result.pes_uf,
      pes_cep: result.pes_cep,
      pes_cnpj_cpf: result.pes_cnpj_cpf,
      pes_insc_estadual: result.pes_insc_estadual,
      pes_celular: result.pes_celular,
      cod_tipo_contribuinte: result.cod_tipo_contribuinte,
      cod_pessoa: result.cod_pessoa,
      pes_tipo: result.pes_tipo,
    })
    setTipoDestinatario(result.pes_tipo || 'F')
    setTipoContribuinteDestinatario(String(result.cod_tipo_contribuinte || '9'))
    setSearchResults([])
  }

  useEffect(() => {
    const total = nfeItens.reduce(
      (acc, item) => acc + parseFloat(item.valortotalliquido || 0),
      0,
    )
    setTotalnfe(total)
  }, [nfeItens])

  // ─── Fetch NF-e ────────────────────────────────────────────────────────────
  const fetchNfe = async (silent = false) => {
    try {
      if (!silent) setLoading(true)
      const response = await apinode.get(
        `/nfe/lista/${idnfe}/${localStorage.idconta}`,
      )
      const d = response.data[0]
      const {
        numnfe,
        serie,
        pes_razao,
        datavenda,
        pes_cep,
        pes_logradouro,
        pes_numero,
        pes_bairro,
        pes_cidade,
        pes_uf,
        pes_ibge,
        codcliente,
        totalpedido,
        valorfrete,
        idtransportadora,
        natureza,
        volume,
        pesol,
        pesob,
        emp_conta,
        itens,
        tipo,
        erro,
        status,
        complemento,
        duplicatas,
        frete,
        chave,
        link_nfe,
        chave_ref, // ← recebe do backend
      } = d
      setLink(link_nfe)
      setNumeroNFe(numnfe)
      setDestinatarioValue(pes_razao)
      setDataVenda(format(new Date(datavenda), 'yyyy-MM-dd'))
      setSerie(serie)
      setCep(pes_cep)
      setLogradouro(pes_logradouro)
      setPesNum(pes_numero)
      setPEsBairro(pes_bairro)
      setPesCidade(pes_cidade)
      setUf(pes_uf)
      setIbge(pes_ibge)
      setIdCliente(codcliente)
      setEndereco(d.endereco)
      setTotalnfe(totalpedido)
      setNfeItens(itens)
      setFrete(valorfrete)
      setChave(chave)
      setChaveRef(chave_ref || '') // ← popula o campo
      if (
        d?.transportador?.[0]?.pes_razao &&
        d?.transportador?.[0]?.pes_cnpj_cpf
      ) {
        setNomeTransp(d.transportador[0].pes_razao)
        setCnpjTransp(d.transportador[0].pes_cnpj_cpf)
      } else {
        setNomeTransp(null)
        setCnpjTransp(null)
      }
      setIdTransp(idtransportadora || null)
      setVolume(volume)
      setPesol(pesol)
      setPesob(pesob)
      setNatureza(natureza)
      setEmpConta(emp_conta)
      setTipo(tipo)
      setErro(erro)
      setStatus(status)
      setObservacaoInterna(complemento)
      setParcelas(duplicatas)
      setTipoFrete(frete)
      setTipoDestinatario(d.endereco?.pes_tipo || 'F')
      setTipoContribuinteDestinatario(
        String(d.endereco?.cod_tipo_contribuinte || '9'),
      )
      if (emp_conta) {
        try {
          const resRegime = await apinode.get(
            `/nfe/buscaregime/${localStorage.idconta}`,
            { params: { contaGeracao: emp_conta } },
          )
          setRegime(resRegime.data?.[0]?.regime ?? null)
        } catch (e) {
          console.error('Erro ao buscar regime:', e)
        }
      }
    } catch (err) {
      sendErrorApiMessage(err, 'Erro ao obter informação da NFe')
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    if (idnfe !== 'novo') fetchNfe(true)
  }, [idnfe, reload])

  const handleChangeOperacoes = async (id) => {
    try {
      const r = await apinode.get(
        `/nfe/operacoes/${id}/${localStorage.idconta}`,
      )
      setNfeItens((prev) =>
        prev.map((produto) =>
          r.data[0]
            ? {
                ...produto,
                csticms: r.data[0].cst,
                csosn: r.data[0].csosn,
                cfop: r.data[0].cfop,
              }
            : produto,
        ),
      )
    } catch (e) {
      console.error(e.message)
    }
  }

  const handleNatureza = (v) => {
    setNatureza(v)
    setNfeItens((prev) =>
      prev.map((item) => {
        const cfop = getCfopPorNatureza(v, item.ncm, uf, regime)
        const tribut = getCstPorNatureza(v, item.ncm, regime)
        return {
          ...item,
          cfop,
          csticms: tribut.csticms !== '' ? tribut.csticms : item.csticms,
          csosn: tribut.csosn !== '' ? tribut.csosn : item.csosn,
        }
      }),
    )
  }

  useEffect(() => {
    if (!nfeItens.length) return
    if (!tipo) return

    const ufDest = (endereco?.pes_uf || uf || '').toUpperCase().trim()
    const isPJ = (endereco?.pes_tipo || 'F').toUpperCase() === 'J'
    const isInter = ufDest && ufDest !== 'SP'

    let naturezaAuto = null

    if (chaveRef) {
      naturezaAuto = tipo === 'E' ? '111' : '115'
    } else if (tipo === 'S') {
      naturezaAuto = isInter ? (isPJ ? '119' : '117') : isPJ ? '118' : '116'
    }

    if (naturezaAuto && naturezaAuto !== String(natureza)) {
      handleNatureza(naturezaAuto)
      toast.info('Natureza aplicada automaticamente', {
        autoClose: 3000,
        position: 'top-center',
      })
    }
  }, [
    tipo,
    chaveRef,
    uf,
    endereco?.pes_uf,
    endereco?.pes_tipo,
    nfeItens.length,
  ])

  // ─── Consultar / Emitir ────────────────────────────────────────────────────
  const handleConsultarStatus = async (id, contaEmp) => {
    try {
      setIsConsultarLoading(true)
      const r = await apinode.get(
        `/nfe/consultar/${id}/${contaEmp}/${localStorage.idconta}`,
      )
      await fetchNfe(true)
      setStatusConsultar(r.data)
      toast.success(r.data.message)
    } catch (err) {
      sendErrorApiMessage(erro, 'Erro ao consultar a nota')
    } finally {
      setIsConsultarLoading(false)
    }
  }

  const handleDadosFicais = async (id, contaEmp) => {
    try {
      setIsEnviarDadosLoading(true)
      await apinode.get(
        `/nfe/dadosfiscais/${id}/${contaEmp}/${localStorage.idconta}`,
      )
      toast.success('Dados fiscais enviados com sucesso!')
    } catch (error) {
      sendErrorApiMessage(erro, 'Erro ao enviar os dados fiscais')
    } finally {
      setIsEnviarDadosLoading(false)
    }
  }

  const updateLinkPrefix = (link) =>
    link.replace(
      'http://erp.belahome.com.br:9091',
      'http://fiscal.ziphub.com.br',
    )

  const handlePdf = (link, idnfe) => {
    setReload((prev) => !prev)
    if (!link || !link.includes('http://erp.belahome.com.br:9091')) {
      apinode({
        url: `/nfe/fiscal_pdf/${localStorage.idconta}`,
        method: 'GET',
        params: { id: idnfe },
      })
        .then((r) => {
          const w = window.open('', '_blank')
          w.document.body.innerHTML = r.data
          w.print()
        })
        .catch((e) => console.error(e))
    } else window.open(updateLinkPrefix(link), '_blank')
  }

  async function consultarNfe() {
    function tratarXML(m) {
      return typeof m !== 'string'
        ? m
        : m
            .replace(/<\/?[^>]+(>|$)/g, '')
            .replace(/\n/g, '<br>')
            .trim()
    }
    try {
      setTransmitting(true)
      const r = await apinode.post(
        `/nfe/validarxml/${idnfe}/${localStorage.idconta}/${localStorage.idconta}`,
      )
      await fetchNfe(true)
      Swal.fire({
        title: 'Retorno da Validação',
        html: `<div style="text-align:left;">${tratarXML(r.data)}</div>`,
        icon: 'success',
        confirmButtonText: 'Ok',
      })
    } catch (error) {
      const msg =
        typeof error.response?.data === 'string'
          ? error.response.data.replace(/<\/?[^>]+(>|$)/g, '').trim()
          : 'Erro desconhecido'
      Swal.fire({
        title: 'Erro ao validar NF-e',
        html: `<div style="text-align:left;">${msg}</div>`,
        icon: 'error',
        confirmButtonText: 'Tentar novamente',
      })
    } finally {
      setTransmitting(false)
    }
  }

  const extractErrorMessage = (errorData) => {
    if (!errorData) return 'Erro desconhecido ao gerar NF-e'
    try {
      if (typeof errorData === 'string') {
        const p = JSON.parse(errorData)
        if (p.erro) return p.erro
      }
      if (typeof errorData === 'object')
        return errorData.message || errorData.erro || JSON.stringify(errorData)
      return errorData
    } catch (e) {
      return errorData
    }
  }

  const EmitirNFe = async () => {
    const tratarXML = (m) =>
      typeof m !== 'string'
        ? m
        : m
            .replace(/<\/?[^>]+(>|$)/g, '')
            .replace(/\n/g, '<br>')
            .trim()
    setEmissaoSteps([])
    setTransmitting(true)
    setShowModalTrans(true)
    try {
      // ── Step 0: Gravar antes de emitir ──────────────────────────────────────
      addStep('gravar', 'Salvando dados da NF-e...')
      try {
        const dadosNfe = {
          codcliente: id_cliente,
          itens: nfeItens,
          natureza,
          datavenda,
          volume,
          pesob,
          pesol,
          idtransportadora: idtransp,
          totalpedido: totalnfe,
          emp_conta,
          tipo,
          complemento: observacaoInterna,
          parcelas,
          frete: tipoFrete,
          valorfrete: frete,
          chave_ref: chaveRef,
        }
        if (idnfe === 'novo') {
          throw new Error('Salve a NF-e antes de emitir.')
        }
        await apinode.put(`nfe/${idnfe}/${localStorage.idconta}`, dadosNfe)
        updateStep('gravar', 'success', 'Dados salvos')
      } catch (err) {
        updateStep('gravar', 'error', err.message || 'Erro ao salvar')
        toast.error(
          'Erro ao salvar NF-e: ' + (err.message || 'Erro desconhecido'),
        )
        return
      }
      if (emp_conta && chave) {
        addStep('sefaz', 'Consultando situação na SEFAZ...')
        try {
          const res = await apidfe.get(
            `/gnre/consultar-nfe/${localStorage.idconta}/${idnfe}`,
          )
          const cStat = res.data?.cStat
          const xMotivo = res.data?.xMotivo ?? ''
          const nProt = res.data?.protocolo?.nProt ?? null
          setSefazCstat(cStat)
          if (cStat === '100') {
            updateStep(
              'sefaz',
              'warning',
              `Já autorizada — protocolo ${nProt ?? 'não disponível'}`,
            )
            setShowModalTrans(false)
            const confirm = await Swal.fire({
              title: '✅ Nota já autorizada na SEFAZ',
              html: `<div style="text-align:left;"><b>Protocolo:</b> ${nProt ?? 'não disponível'}<br/><b>Situação:</b> ${xMotivo}<br/><br/>Deseja atualizar o protocolo no sistema?</div>`,
              icon: 'info',
              showCancelButton: true,
              confirmButtonText: 'Sim, atualizar protocolo',
              cancelButtonText: 'Não',
            })
            if (confirm.isConfirmed) {
              try {
                const rp = await apidfe.post(
                  `/gnre/protocolar-nfe/${localStorage.idconta}`,
                  { nfe_id: Number(idnfe) },
                )
                if (rp.data.success) {
                  toast.success(`✅ Protocolo atualizado: ${rp.data.protocolo}`)
                  setStatus('T')
                  await fetchNfe(true)
                } else
                  toast.warning(
                    `⚠️ ${rp.data.statusEmissao}: ${rp.data.xMotivo}`,
                  )
              } catch (e) {
                toast.error(
                  'Erro ao atualizar protocolo: ' +
                    (e?.response?.data?.message || e.message),
                )
              }
            }
            return
          }
          if (cStat === '101') {
            updateStep('sefaz', 'error', 'Nota cancelada na SEFAZ')
            setShowModalTrans(false)
            await Swal.fire({
              title: '⚠️ Nota cancelada na SEFAZ',
              html: `<div style="text-align:left;">${xMotivo}</div>`,
              icon: 'warning',
              confirmButtonText: 'Ok',
            })
            setStatus('I')
            await fetchNfe(true)
            return
          }
          updateStep(
            'sefaz',
            'success',
            cStat ? `cStat ${cStat}` : 'Prosseguindo',
          )
        } catch (_) {
          updateStep('sefaz', 'warning', 'Consulta falhou — continuando')
        }
      }
      addStep('validacao', 'Validando dados da NF-e...')
      const validacao = await apinode.get(
        `/nfe/validanfe/${idnfe}/${localStorage.idconta}`,
      )
      if (!validacao.data.match) {
        const msg = validacao.data.message
        updateStep('validacao', 'error', msg)
        fetchNfe(true)
        toast.error('Erro ao validar NF-e: ' + msg)
        Swal.fire({
          title: 'Erro na Validação',
          html: `<div style="text-align:left;">${tratarXML(msg)}</div>`,
          icon: 'error',
          confirmButtonText: 'Ok',
        })
        return
      }
      updateStep('validacao', 'success', 'Dados válidos')
      addStep('enfileirar', 'Enfileirando no servidor de emissão...')
      let jobId
      try {
        const enqueue = await apinode.post(
          `/nfe/gerar/${idnfe}/${emp_conta}/${localStorage.idconta}/${localStorage.username}`,
          null,
          { timeout: 15000 },
        )
        jobId = enqueue.data?.jobId
        if (!jobId) throw new Error('Servidor não retornou jobId')
        updateStep(
          'enfileirar',
          'success',
          `Enfileirado — aguardando processamento`,
        )
      } catch (err) {
        if (err.response?.status === 429) {
          updateStep('enfileirar', 'warning', 'Fila cheia')
          toast.warning('Fila cheia — tente novamente em instantes.')
          return
        }
        updateStep('enfileirar', 'error', err.message)
        throw err
      }
      addStep('emissao', 'Emitindo na SEFAZ...')
      const MAX_POLL = 40
      const POLL_MS = 4000
      for (let i = 0; i < MAX_POLL; i++) {
        updateStep(
          'emissao',
          'loading',
          `Aguardando processamento... (${i + 1}/${MAX_POLL})`,
        )
        await new Promise((r) => setTimeout(r, POLL_MS))
        try {
          const poll = await apinode.get(`/nfe/status/${jobId}`, {
            timeout: 8000,
          })
          const { status: jobStatus, result } = poll.data
          if (jobStatus === 'success') {
            const parsed =
              typeof result === 'string'
                ? (() => {
                    try {
                      return JSON.parse(result)
                    } catch {
                      return { message: result }
                    }
                  })()
                : result
            updateStep(
              'emissao',
              'success',
              parsed?.message || 'NFe emitida com sucesso',
            )
            addStep('finalizar', 'Atualizando dados...')
            setStatus('T')
            await fetchNfe(true)
            updateStep('finalizar', 'success', 'Concluído')
            await new Promise((r) => setTimeout(r, 600))
            setShowModalTrans(false)
            Swal.fire({
              title: 'NF-e Emitida ✅',
              html: `<div id="nfe-result" style="text-align:left;">${tratarXML(parsed?.message || 'NFe Emitida com sucesso!')}</div>`,
              icon: 'success',
              showCancelButton: true,
              confirmButtonText: 'Ok',
              cancelButtonText: 'Baixar PDF',
            }).then((r) => {
              if (r.dismiss === Swal.DismissReason.cancel)
                handlePdf(linknfe, idnfe)
            })
            return
          }
          if (jobStatus === 'error') {
            const parsed =
              typeof result === 'string'
                ? (() => {
                    try {
                      return JSON.parse(result)
                    } catch {
                      return { message: result }
                    }
                  })()
                : result
            const msg =
              parsed?.erro || parsed?.message || JSON.stringify(parsed)
            updateStep('emissao', 'error', msg)
            fetchNfe(true)
            toast.error('Erro ao emitir NF-e: ' + msg)
            Swal.fire({
              title: 'Erro ao Emitir NF-e',
              html: `<div style="text-align:left;">${tratarXML(msg)}</div>`,
              icon: 'error',
              confirmButtonText: 'Ok',
            })
            return
          }
        } catch (pollErr) {
          console.warn(`[polling] falha tentativa ${i + 1}:`, pollErr.message)
        }
      }
      updateStep('emissao', 'warning', 'Timeout — verifique na SEFAZ')
      Swal.fire({
        title: 'Timeout',
        html: '<div style="text-align:left;">A NF-e pode ter sido processada.<br/><br/>Use <b>"Consultar SEFAZ"</b> para verificar.</div>',
        icon: 'warning',
        confirmButtonText: 'Ok',
      })
    } catch (error) {
      const msg = extractErrorMessage(error.response?.data || error.message)
      setEmissaoSteps((prev) =>
        prev.map((s) =>
          s.status === 'loading' ? { ...s, status: 'error', detail: msg } : s,
        ),
      )
      fetchNfe(true)
      toast.error('Erro: ' + msg)
    } finally {
      setTransmitting(false)
    }
  }

  const handleConsultarSefaz = async () => {
    if (!emp_conta) {
      toast.warning('Conta da empresa não carregada')
      return
    }
    try {
      setIsConsultarSefazLoading(true)
      const r = await apidfe.get(
        `/gnre/consultar-nfe/${localStorage.idconta}/${idnfe}`,
      )
      const { cStat, xMotivo, protocolo } = r.data
      setSefazCstat(cStat)
      if (cStat === '100') {
        toast.success(
          `✅ Autorizada${protocolo?.nProt ? ` | nProt: ${protocolo.nProt}` : ''} — protocolando...`,
        )
        try {
          const rp = await apidfe.post(
            `/gnre/protocolar-nfe/${localStorage.idconta}`,
            { nfe_id: Number(idnfe) },
          )
          if (rp.data.success) {
            toast.success(`✅ Protocolo gravado: ${rp.data.protocolo}`)
            setStatus('T')
            await fetchNfe(true)
          }
        } catch (errProt) {
          toast.warning(
            'Erro ao gravar protocolo: ' +
              (errProt?.response?.data?.message || errProt.message),
          )
        }
      } else if (cStat === '101') {
        toast.warning(`⚠️ ${cStat} — Cancelada na SEFAZ.`)
        setStatus('I')
        await fetchNfe(true)
      } else {
        toast.info(`ℹ️ ${cStat} — ${xMotivo}`)
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || 'Erro ao consultar na SEFAZ')
    } finally {
      setIsConsultarSefazLoading(false)
    }
  }

  const handleAdicionarProtocolo = async () => {
    if (!emp_conta) {
      toast.warning('Conta da empresa não carregada')
      return
    }
    try {
      setIsProtocolarLoading(true)
      const r = await apidfe.post(
        `/gnre/protocolar-nfe/${localStorage.idconta}`,
        { nfe_id: Number(idnfe) },
      )
      const { success, protocolo, statusEmissao, xMotivo } = r.data
      if (success) {
        toast.success(
          `✅ Protocolo adicionado: ${protocolo} — ${statusEmissao}`,
        )
        await fetchNfe(true)
      } else toast.warning(`⚠️ ${statusEmissao}: ${xMotivo}`)
    } catch (err) {
      toast.error(err?.response?.data?.message || 'Erro ao adicionar protocolo')
    } finally {
      setIsProtocolarLoading(false)
    }
  }

  const handleDanfePdf = () => {
    if (!emp_conta) {
      toast.warning('Conta da empresa não carregada')
      return
    }
    window.open(
      `${apidfe.defaults.baseURL}/gnre/danfe/${localStorage.idconta}/${idnfe}`,
      '_blank',
    )
  }

  // ─── Modal itens ───────────────────────────────────────────────────────────
  const addNFeItensArray = (e) => {
    e.preventDefault()
    const index = nfeItens.findIndex((item) => item.id === editedItem.id)
    if (index !== -1) {
      setNfeItens(
        nfeItens.map((item, idx) =>
          idx === index
            ? {
                ...editedItem,
                valortotalliquido: calculateTotalLiquido(),
                valortotal: calculateTotalItem(),
                valoricms:
                  ((editedItem.bcicms || 0) * (editedItem.porcicms || 0)) / 100,
                valoripi:
                  ((editedItem.valortotalliquido || 0) *
                    (editedItem.porcipi || 0)) /
                  100,
              }
            : item,
        ),
      )
    }
    setShowModal(false)
  }

  const handleBCicms = () => {
    const v = document.getElementById('formValorTotalLiquido').value
    setEditedItem({ ...editedItem, bcicms: v })
  }

  const openEditModal = (item) => {
    setEditedItem(item)
    setShowModal(true)
  }
  const calculateTotalLiquido = () => {
    if (!editedItem.qtde || !editedItem.valorunitario) return 0
    return (
      editedItem.qtde * editedItem.valorunitario - (editedItem.desconto || 0)
    )
  }
  const calculateTotalItem = () => {
    if (!editedItem.qtde || !editedItem.valorunitario) return 0
    return editedItem.qtde * editedItem.valorunitario
  }

  const alternarItems = () => {
    const index = nfeItens.findIndex((item) => item.id === editedItem.id)
    if (index !== -1) {
      const u = [...nfeItens]
      u[index] = {
        ...editedItem,
        valortotalliquido: calculateTotalLiquido(),
        valortotal: calculateTotalItem(),
      }
      setNfeItens(u)
    }
  }

  const calcularTotalItensArray = () => {
    setNfeItens(
      nfeItens.map((item) => {
        if (item.qtde && item.valorunitario) {
          const vb = item.qtde * item.valorunitario
          return {
            ...item,
            valortotalliquido: vb - (item.desconto || 0),
            valortotal: vb,
          }
        }
        return item
      }),
    )
  }

  const handleSearchWithTimeout = (value) => {
    clearTimeout(typingTimeout)
    setTypingTimeout(
      setTimeout(() => {
        if (value.length >= 3)
          handleSearch() // ← removido setLoading
        else setSearchResultsProd([])
      }, TYPING_TIMEOUT),
    )
  }

  const handleSearch = async () => {
    setIsSearchingProd(true) // ← estado próprio, não setLoading
    try {
      const r = await apinode.get('estoque/listaproduto', {
        params: { sku: editedItem.descricao, conta: localStorage.idconta },
      })
      setSearchResultsProd(r.data)
      setShowResults(true)
    } catch (e) {
      console.error(e)
    } finally {
      setIsSearchingProd(false)
    }
  }

  const handleSelect = (selectedItem) => {
    const ncm = selectedItem.CODNCM
    const cfop = natureza
      ? getCfopPorNatureza(natureza, ncm, uf, regime)
      : editedItem.cfop
    const trib = natureza
      ? getCstPorNatureza(natureza, ncm, regime)
      : { csticms: editedItem.csticms, csosn: editedItem.csosn }
    setEditedItem({
      ...editedItem,
      idproduto: selectedItem.CODPRODUTO,
      descricao: selectedItem.DESCRICAO,
      qtde: 1,
      valorunitario: selectedItem.PRECOVENDA,
      ncm,
      sku: selectedItem.SKU,
      unidade: selectedItem.UNIDADE,
      cfop,
      csticms: trib.csticms !== '' ? trib.csticms : editedItem.csticms,
      csosn: trib.csosn !== '' ? trib.csosn : editedItem.csosn,
    })
    setSearchResultsProd([])
  }

  const buildIcmsPayload = (vlrLiquido, ufDest, cst60) => {
    const UF_EMP = 'SP'
    const aliquotaInter = getAliquotaInterestadual(ufDest)
    const aliquotaSP = 18
    const aplicaDifal = getAplicaDifal(
      regime,
      ufDest,
      tipoDestinatario,
      tipoContribuinteDestinatario,
    )
    if (cst60)
      return {
        bcicms: '',
        valoricms: '',
        porcicms: aplicaDifal ? String(aliquotaInter) : '',
        porcicmsest: aplicaDifal ? String(aliquotaSP) : '',
      }
    const aliquota = ufDest === UF_EMP ? aliquotaSP : aliquotaInter
    const bcicms = vlrLiquido.toFixed(2)
    const valoricms = ((vlrLiquido * aliquota) / 100).toFixed(2)
    return {
      bcicms,
      porcicms: String(aliquota),
      valoricms: parseFloat(valoricms),
      porcicmsest: aplicaDifal ? String(aliquotaSP) : '',
    }
  }

  const calcularICMSTodosItens = () => {
    const ufDest = (uf || '').toUpperCase().trim()
    if (!ufDest) {
      toast.warning('UF do destinatário não informada.')
      return
    }
    if (!regime) {
      toast.warning('Regime da empresa não carregado.')
      return
    }
    const aplicaDifal = getAplicaDifal(
      regime,
      ufDest,
      tipoDestinatario,
      tipoContribuinteDestinatario,
    )
    const aliquotaInter = getAliquotaInterestadual(ufDest)
    const aliquotaSP = 18
    let atualizados = 0
    const itensAtualizados = nfeItens.map((item) => {
      const vlrLiquido = parseFloat(item.valortotalliquido || 0)
      if (!vlrLiquido || vlrLiquido <= 0) return item
      let payload = {}
      if (regime === 1) {
        const csosn = String(item.csosn || '')
        if (csosn === '28')
          payload = { bcicms: 0, valoricms: 0, porcicms: 0, porcicmsest: 0 }
        else if (csosn === '27')
          payload = { bcicms: 0, valoricms: 0, porcicms: 0, porcicmsest: 0 }
        else payload = { bcicms: 0, valoricms: 0, porcicms: 0, porcicmsest: 0 }
      } else {
        const isCst60 = String(item.csticms || '') === '20'
        payload = buildIcmsPayload(vlrLiquido, ufDest, isCst60)
      }
      atualizados++
      return { ...item, ...payload }
    })
    setNfeItens(itensAtualizados)
    const difal = aliquotaSP - aliquotaInter
    toast.success(
      `⚡ BC/ICMS calculado para ${atualizados} item(s) — UF: ${ufDest} | Regime: ${regime === 1 ? 'Simples' : 'Normal'}` +
        (aplicaDifal
          ? ` | DIFAL: ${aliquotaSP}% − ${aliquotaInter}% = ${difal}%`
          : ` | Sem DIFAL`),
    )
  }

  const calcularICMS = () => {
    if (!editedItem) return
    const vlrLiquido = parseFloat(calculateTotalLiquido())
    if (!vlrLiquido || vlrLiquido <= 0) {
      toast.warning('Informe quantidade e valor unitário antes de calcular.')
      return
    }
    const ufDest = (uf || '').toUpperCase().trim()
    if (!ufDest) {
      toast.warning('UF do destinatário não informada.')
      return
    }
    let payload = {}
    if (regime === 1) {
      payload = { bcicms: 0, valoricms: 0, porcicms: 0, porcicmsest: 0 }
      setEditedItem((prev) => ({ ...prev, ...payload }))
      toast.info('Simples Nacional — BC/ICMS zerados.')
      return
    }
    const isCst60 = String(editedItem.csticms || '') === '20'
    payload = buildIcmsPayload(vlrLiquido, ufDest, isCst60)
    const aplicaDifal = getAplicaDifal(
      regime,
      ufDest,
      tipoDestinatario,
      tipoContribuinteDestinatario,
    )
    const aliquotaInter = getAliquotaInterestadual(ufDest)
    const aliquotaSP = 18
    setEditedItem((prev) => ({
      ...prev,
      valortotalliquido: isCst60 ? prev.valortotalliquido : vlrLiquido,
      valortotal: isCst60 ? prev.valortotal : calculateTotalItem(),
      ...payload,
    }))
    const aliquota = ufDest === 'SP' ? aliquotaSP : aliquotaInter
    const difal = aliquotaSP - aliquotaInter
    toast.success(
      `UF: ${ufDest} | Alíq: ${aliquota}% | ICMS: R$ ${payload.valoricms}` +
        (aplicaDifal
          ? ` | DIFAL: ${aliquotaSP}% − ${aliquotaInter}% = ${difal}%`
          : ` | Sem DIFAL`),
    )
  }

  const handleSearchtTransp = async () => {
    try {
      const r = await apinode.get(
        `/nfe/listatransportador/${localStorage.idconta}`,
        { params: { dados: nomeTransp } },
      )
      setSearchResultsTrans(r.data)
    } catch (e) {
      console.error(e)
    }
  }

  const handleSelectTransp = (item) => {
    setIdTransp(item.cod_pessoa)
    setNomeTransp(item.pes_razao)
    setCnpjTransp(item.pes_cnpj_cpf)
    setSearchResultsTrans([])
  }

  function buscaCep() {
    const c = document.getElementById('cep').value.replace(/\D/g, '')
    const xhr = new XMLHttpRequest()
    xhr.open('GET', `https://viacep.com.br/ws/${c}/json/`)
    xhr.onload = function () {
      const r = JSON.parse(xhr.responseText)
      setEndereco({
        ...endereco,
        pes_ibge: r.ibge,
        pes_bairro: r.bairro,
        pes_cidade: r.localidade,
        pes_uf: r.uf,
        pes_logradouro: r.logradouro,
      })
    }
    xhr.send()
  }

  const HandleCadastrarCliente = (e) => {
    e.preventDefault()
    apinode
      .post(`pessoa/${localStorage.idconta}`, endereco)
      .then(() => {
        toast.success('Cliente cadastrado com sucesso!')
        setLoading(false)
      })
      .catch((error) => {
        console.error(error)
        toast.error('Erro, ' + error.response.data.message)
        setLoading(false)
      })
  }

  const handleDelete = (id) => {
    if (window.confirm('Excluir este item?'))
      setNfeItens(nfeItens.filter((item) => item.id !== id))
  }
  const handleAddItem = () => {
    const n = {
      id: uuidv4(),
      descricao: '',
      qtde: 0,
      valorunitario: 0,
      ncm: '',
      idnfe,
    }
    setNfeItens([...nfeItens, n])
    openEditModal(n)
  }
  const handleSubmit = (e) => e.preventDefault()

  // ─── Render ────────────────────────────────────────────────────────────────
  return (
    <ContentLoading
      isLoading={loading}
      loadingText="Carregando nota fiscal..."
    >
      <GlobalStyle />
      <PageWrap>
        <Navbar />

        {/* ── Header fixo ── */}
        <PageHeader>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <div
              style={{
                width: 6,
                height: 28,
                background: '#2563eb',
                borderRadius: 3,
              }}
            />
            <h1>Edição e Emissão de NF-e</h1>
            {numeroNFe && (
              <span
                style={{
                  background: '#f4f4f5',
                  color: '#52525b',
                  fontFamily: 'Courier New, monospace',
                  fontSize: 12,
                  padding: '3px 10px',
                  borderRadius: 5,
                  border: '1px solid #e4e4e7',
                }}
              >
                #{numeroNFe} · Série {serie}
              </span>
            )}
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            {getStatusLabel(status)}
            {emp_conta && (
              <span
                style={{
                  background: '#f4f4f5',
                  color: '#71717a',
                  fontSize: 11,
                  padding: '3px 10px',
                  borderRadius: 5,
                  border: '1px solid #e4e4e7',
                }}
              >
                Conta {emp_conta}
              </span>
            )}
          </div>
        </PageHeader>

        <div style={{ width: '100%', padding: '16px 24px 100px' }}>
          {/* ── Alerta de erro ── */}
          {erro && status !== 'T' && (
            <div
              style={{
                background: '#fee2e2',
                border: '1px solid #fca5a5',
                borderRadius: 10,
                padding: '10px 16px',
                marginBottom: 16,
                fontSize: 13,
                color: '#991b1b',
                display: 'flex',
                alignItems: 'center',
                gap: 8,
              }}
            >
              <span>⚠️</span> {erro}
            </div>
          )}

          <Form onSubmit={handleSubmit}>
            {/* ══════════════════════════════════════════════════════════════════
                SEÇÃO 1 — IDENTIFICAÇÃO DA NF-e
            ══════════════════════════════════════════════════════════════════ */}
            <SectionCard>
              <SectionHeader>
                <span className="badge-section">01</span>
                <h3>Identificação</h3>
              </SectionHeader>
              <SectionBody>
                <Row className="g-3">
                  {/* Tipo */}
                  <Col md={2}>
                    <label className="nfe-label">Tipo</label>
                    <select
                      className="nfe-select form-control"
                      value={tipo}
                      onChange={(e) => setTipo(e.target.value)}
                    >
                      <option value="S">Saída</option>
                      <option value="E">Entrada</option>
                    </select>
                  </Col>

                  {/* Número */}
                  <Col md={2}>
                    <label className="nfe-label">Número</label>
                    <input
                      disabled
                      className="nfe-input form-control"
                      type="text"
                      value={numeroNFe}
                    />
                  </Col>

                  {/* Série */}
                  <Col md={1}>
                    <label className="nfe-label">Série</label>
                    <input
                      disabled
                      className="nfe-input form-control"
                      type="text"
                      value={serie}
                    />
                  </Col>

                  {/* Natureza */}
                  <Col md={4}>
                    <label className="nfe-label">Natureza da Operação</label>
                    <select
                      className="nfe-select form-control"
                      value={natureza}
                      onChange={(e) => handleNatureza(e.target.value)}
                    >
                      <option value="120">SIMPLES REMESSA</option>
                      <option value="110">VENDA DE MERCADORIAS</option>
                      <option value="116">VENDA ESTADUAL PESSOA FISICA</option>
                      <option value="118">
                        VENDA ESTADUAL PESSOA JURIDICA
                      </option>
                      <option value="117">
                        VENDA FORA DO ESTADO PESSOA FISICA
                      </option>
                      <option value="119">
                        VENDA FORA DO ESTADO PESSOA JURIDICA
                      </option>
                      <option value="112">BONIFICACAO</option>
                      <option value="111">DEVOLUCAO DE VENDA</option>
                      <option value="115">DEVOLUCAO DE MERCADORIA</option>
                      <option value="113">
                        REMESSA DE MERCADORIA OU BEM PARA CONSERTO OU REPARO
                      </option>
                      <option value="114">
                        OUTRA SAIDA DE MERCAD. OU PRESTAÇÃO DE SERV. NÃO ESPEC
                      </option>
                    </select>
                  </Col>

                  {/* Data */}
                  <Col md={2}>
                    <label className="nfe-label">Data da Venda</label>
                    <input
                      className="nfe-input form-control"
                      type="date"
                      value={datavenda}
                      onChange={(e) => setDataVenda(e.target.value)}
                    />
                  </Col>

                  {/* Chave de Acesso */}
                  <Col md={8}>
                    <label className="nfe-label">Chave de Acesso</label>
                    <input
                      disabled
                      className="nfe-input form-control"
                      type="text"
                      value={chave}
                      style={{
                        fontFamily: 'Courier New, monospace',
                        fontSize: 11,
                        letterSpacing: '1px',
                        color: '#1e40af',
                      }}
                    />
                  </Col>

                  {/* Conta */}
                  <Col md={3}>
                    <label className="nfe-label">Conta</label>
                    <input
                      disabled
                      className="nfe-input form-control"
                      type="text"
                      value={emp_conta}
                    />
                  </Col>
                </Row>

                {/* ── NF-e Referenciada — aparece sempre, destaque em devolução ── */}
                <ChaveRefBanner
                  style={
                    NATUREZAS_COM_REF.includes(String(natureza))
                      ? {
                          borderColor: '#fbbf24',
                          background:
                            'linear-gradient(135deg, #fffbeb 0%, #fef9c3 100%)',
                        }
                      : {}
                  }
                >
                  <span className="icon">
                    {NATUREZAS_COM_REF.includes(String(natureza)) ? '🔗' : '📎'}
                  </span>
                  <div className="info">
                    <strong>
                      {NATUREZAS_COM_REF.includes(String(natureza))
                        ? '⚠ NF-e Referenciada — obrigatória para devolução'
                        : 'NF-e Referenciada (opcional)'}
                    </strong>
                    <span>
                      Chave de acesso da nota fiscal de origem (44 dígitos)
                    </span>
                  </div>
                  <input
                    type="text"
                    maxLength={44}
                    placeholder="0000 0000 0000 0000 0000 0000 0000 0000 0000 0000 0000"
                    value={chaveRef}
                    onChange={(e) =>
                      setChaveRef(
                        e.target.value.replace(/\D/g, '').slice(0, 44),
                      )
                    }
                    style={
                      NATUREZAS_COM_REF.includes(String(natureza))
                        ? {
                            borderColor: '#fbbf24',
                            background: '#fffbeb',
                            color: '#92400e',
                          }
                        : {}
                    }
                  />
                  {chaveRef.length > 0 && chaveRef.length < 44 && (
                    <span
                      style={{ fontSize: 11, color: '#ef4444', flexShrink: 0 }}
                    >
                      {chaveRef.length}/44
                    </span>
                  )}
                  {chaveRef.length === 44 && (
                    <span
                      style={{ fontSize: 11, color: '#059669', flexShrink: 0 }}
                    >
                      ✓ 44
                    </span>
                  )}
                  {chaveRef && (
                    <button
                      type="button"
                      onClick={() => setChaveRef('')}
                      style={{
                        background: 'none',
                        border: 'none',
                        color: '#9ca3af',
                        cursor: 'pointer',
                        fontSize: 16,
                        padding: '0 4px',
                        flexShrink: 0,
                      }}
                      title="Limpar"
                    >
                      ×
                    </button>
                  )}
                </ChaveRefBanner>
              </SectionBody>
            </SectionCard>

            {/* ══════════════════════════════════════════════════════════════════
                SEÇÃO 2 — DESTINATÁRIO
            ══════════════════════════════════════════════════════════════════ */}
            <SectionCard>
              <SectionHeader>
                <span className="badge-section">02</span>
                <h3>Destinatário</h3>
              </SectionHeader>
              <SectionBody>
                <Row className="g-3">
                  <Col md={6}>
                    <label className="nfe-label">Buscar Destinatário</label>
                    <div className="input-group">
                      <input
                        type="text"
                        className="nfe-input form-control"
                        value={destinatarioValue}
                        onChange={handleInputChangeDestinatario}
                        placeholder="Nome ou CNPJ..."
                      />
                      <button
                        type="button"
                        className="btn btn-primary btn-sm"
                        style={{
                          borderRadius: '0 8px 8px 0',
                          padding: '0 14px',
                        }}
                        onClick={() => setShowAddressModal(true)}
                      >
                        <FontAwesomeIcon icon={faEye} />
                      </button>
                    </div>
                    {searchResults.length > 0 && (
                      <div
                        style={{
                          background: '#fff',
                          border: '1px solid #e5e7eb',
                          borderRadius: 8,
                          boxShadow: '0 4px 12px rgba(0,0,0,.08)',
                          marginTop: 4,
                          maxHeight: 200,
                          overflowY: 'auto',
                          zIndex: 99,
                          position: 'relative',
                        }}
                      >
                        {searchResults.map((r) => (
                          <div
                            key={r.cod_pessoa}
                            onClick={() => handleSelectDestinatario(r)}
                            style={{
                              padding: '8px 14px',
                              cursor: 'pointer',
                              borderBottom: '1px solid #f3f4f6',
                              fontSize: 12,
                            }}
                            onMouseEnter={(e) =>
                              (e.currentTarget.style.background = '#eff6ff')
                            }
                            onMouseLeave={(e) =>
                              (e.currentTarget.style.background = '#fff')
                            }
                          >
                            <strong>{r.pes_razao}</strong>{' '}
                            <span style={{ color: '#9ca3af' }}>
                              — {r.pes_cnpj_cpf}
                            </span>
                          </div>
                        ))}
                      </div>
                    )}
                  </Col>
                </Row>

                <Row className="g-3 mt-1">
                  <Col md={2}>
                    <label className="nfe-label">CEP</label>
                    <input
                      className="nfe-input form-control"
                      type="text"
                      value={cep}
                      onChange={(e) => setCep(e.target.value)}
                    />
                  </Col>
                  <Col md={5}>
                    <label className="nfe-label">Logradouro</label>
                    <input
                      className="nfe-input form-control"
                      type="text"
                      value={logradouro}
                      onChange={(e) => setLogradouro(e.target.value)}
                    />
                  </Col>
                  <Col md={1}>
                    <label className="nfe-label">Número</label>
                    <input
                      className="nfe-input form-control"
                      type="text"
                      value={pesNum}
                      onChange={(e) => setPesNum(e.target.value)}
                    />
                  </Col>
                  <Col md={4}>
                    <label className="nfe-label">Bairro</label>
                    <input
                      className="nfe-input form-control"
                      type="text"
                      value={pesBairro}
                      onChange={(e) => setPEsBairro(e.target.value)}
                    />
                  </Col>
                  <Col md={3}>
                    <label className="nfe-label">Cidade</label>
                    <input
                      className="nfe-input form-control"
                      type="text"
                      value={pesCidade}
                      onChange={(e) => setPesCidade(e.target.value)}
                    />
                  </Col>
                  <Col md={3}>
                    <label className="nfe-label">IBGE</label>
                    <input
                      className="nfe-input form-control"
                      type="text"
                      value={codIbge}
                      onChange={(e) => setIbge(e.target.value)}
                    />
                  </Col>
                  <Col md={1}>
                    <label className="nfe-label">UF</label>
                    <input
                      className="nfe-input form-control"
                      type="text"
                      value={uf}
                      onChange={(e) => setUf(e.target.value)}
                      style={{ textTransform: 'uppercase' }}
                    />
                  </Col>
                </Row>
              </SectionBody>
            </SectionCard>

            {/* ══════════════════════════════════════════════════════════════════
                SEÇÃO 3 — ITENS
            ══════════════════════════════════════════════════════════════════ */}
            <SectionCard>
              <SectionHeader>
                <span className="badge-section">03</span>
                <h3>Itens da NF-e</h3>
                <span
                  style={{
                    marginLeft: 'auto',
                    background: '#e0f2fe',
                    color: '#0369a1',
                    fontSize: 11,
                    fontWeight: 700,
                    padding: '2px 10px',
                    borderRadius: 20,
                  }}
                >
                  {nfeItens.length} item(s)
                </span>
              </SectionHeader>
              <SectionBody>
                <div style={{ marginBottom: 10 }}>
                  <button
                    type="button"
                    onClick={handleAddItem}
                    style={{
                      background: '#18181b',
                      color: '#fff',
                      border: 'none',
                      borderRadius: 6,
                      padding: '6px 14px',
                      fontSize: 12,
                      fontWeight: 600,
                      cursor: 'pointer',
                      display: 'inline-flex',
                      alignItems: 'center',
                      gap: 6,
                    }}
                  >
                    <span style={{ fontSize: 16, lineHeight: 1 }}>+</span>{' '}
                    Adicionar Item
                  </button>
                </div>

                <ItemTable>
                  <table>
                    <thead>
                      <tr>
                        <th>Ação</th>
                        <th>ID Prod.</th>
                        <th>Descrição</th>
                        <th>NCM</th>
                        <th>CST</th>
                        <th>CSOSN</th>
                        <th>CFOP</th>
                        <th>Un.</th>
                        <th>Qtde</th>
                        <th>Vl. Unit.</th>
                        <th>Desc.</th>
                        <th>Total</th>
                        <th>Total Líq.</th>
                        <th>BC ICMS</th>
                        <th>% ICMS</th>
                        <th>Vl. ICMS</th>
                        <th>% IPI</th>
                        <th>Vl. IPI</th>
                        <th>BC ST</th>
                        <th>Vl. ST</th>
                        <th>% Est.</th>
                      </tr>
                    </thead>
                    <tbody>
                      {nfeItens.map((item) => (
                        <tr key={item.id}>
                          <td>
                            <div style={{ display: 'flex', gap: 4 }}>
                              <button
                                type="button"
                                onClick={() => openEditModal(item)}
                                style={{
                                  background: '#f59e0b',
                                  color: '#fff',
                                  border: 'none',
                                  borderRadius: 5,
                                  padding: '3px 8px',
                                  cursor: 'pointer',
                                  fontSize: 11,
                                }}
                              >
                                ✏
                              </button>
                              <button
                                type="button"
                                onClick={() => handleDelete(item.id)}
                                style={{
                                  background: '#ef4444',
                                  color: '#fff',
                                  border: 'none',
                                  borderRadius: 5,
                                  padding: '3px 8px',
                                  cursor: 'pointer',
                                  fontSize: 11,
                                }}
                              >
                                ✕
                              </button>
                            </div>
                          </td>
                          <td>{item.idproduto}</td>
                          <td
                            style={{
                              maxWidth: 180,
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                            }}
                          >
                            {item.sku} — {item.descricao}
                          </td>
                          <td>{item.ncm}</td>
                          <td>{item.csticms}</td>
                          <td>{item.csosn}</td>
                          <td>{item.cfop}</td>
                          <td>{item.unidade}</td>
                          <td>{item.qtde}</td>
                          <td>{item.valorunitario}</td>
                          <td>{item.desconto}</td>
                          <td>{item.valortotal}</td>
                          <td>{item.valortotalliquido}</td>
                          <td>{item.bcicms}</td>
                          <td>{item.porcicms}</td>
                          <td>
                            {item.valoricms != null
                              ? (parseFloat(item.valoricms) || 0).toFixed(2)
                              : null}
                          </td>
                          <td>{item.porcipi}</td>
                          <td>{item.valoripi}</td>
                          <td>{item.bcicmsst}</td>
                          <td>{item.valoricmsst}</td>
                          <td>{item.porcicmsest}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </ItemTable>

                <TableActionsRow>
                  <BtnCalc
                    className="blue"
                    type="button"
                    onClick={calcularTotalItensArray}
                  >
                    🔢 Calcular Totais
                  </BtnCalc>
                  <BtnCalc
                    className="green"
                    type="button"
                    onClick={calcularICMSTodosItens}
                  >
                    ⚡ Calcular BC/ICMS — Todos os Itens
                  </BtnCalc>
                </TableActionsRow>

                {/* Total */}
                <div
                  style={{
                    marginTop: 14,
                    display: 'flex',
                    justifyContent: 'flex-end',
                  }}
                >
                  <div
                    style={{
                      background: '#f4f4f5',
                      borderRadius: 7,
                      padding: '10px 18px',
                      border: '1px solid #e4e4e7',
                      display: 'flex',
                      alignItems: 'center',
                      gap: 12,
                    }}
                  >
                    <span
                      style={{
                        color: '#71717a',
                        fontSize: 11,
                        fontWeight: 600,
                        textTransform: 'uppercase',
                        letterSpacing: 1,
                      }}
                    >
                      Total NF-e
                    </span>
                    <span
                      style={{
                        color: '#18181b',
                        fontFamily: 'Courier New, monospace',
                        fontSize: 18,
                        fontWeight: 600,
                      }}
                    >
                      {nfeItens
                        .reduce(
                          (t, i) => t + parseFloat(i.valortotalliquido || 0),
                          0,
                        )
                        .toLocaleString('pt-BR', {
                          style: 'currency',
                          currency: 'BRL',
                        })}
                    </span>
                  </div>
                </div>
              </SectionBody>
            </SectionCard>

            {/* ══════════════════════════════════════════════════════════════════
                SEÇÃO 4 — TRANSPORTE
            ══════════════════════════════════════════════════════════════════ */}
            <SectionCard>
              <SectionHeader>
                <span className="badge-section">04</span>
                <h3>Transporte</h3>
              </SectionHeader>
              <SectionBody>
                <Row className="g-3">
                  <Col md={4}>
                    <label className="nfe-label">Tipo de Frete</label>
                    <select
                      className="nfe-select form-control"
                      value={tipoFrete}
                      onChange={(e) => setTipoFrete(e.target.value)}
                    >
                      <option value="-1">-- Não Selecionado --</option>
                      <option value="0">
                        0 — CIF (por conta do Remetente)
                      </option>
                      <option value="1">
                        1 — FOB (por conta do Destinatário)
                      </option>
                      <option value="2">2 — Terceiros</option>
                      <option value="3">
                        3 — Transporte Próprio — Remetente
                      </option>
                      <option value="4">
                        4 — Transporte Próprio — Destinatário
                      </option>
                      <option value="9">
                        9 — Sem Ocorrência de Transporte
                      </option>
                    </select>
                  </Col>
                  <Col md={2}>
                    <label className="nfe-label">Valor do Frete</label>
                    <input
                      className="nfe-input form-control"
                      type="text"
                      value={frete}
                      onChange={(e) => setFrete(e.target.value)}
                    />
                  </Col>
                  <Col md={2}>
                    <label className="nfe-label">Volume</label>
                    <input
                      className="nfe-input form-control"
                      type="text"
                      value={volume}
                      onChange={(e) => setVolume(e.target.value)}
                    />
                  </Col>
                  <Col md={2}>
                    <label className="nfe-label">Peso Líq. (kg)</label>
                    <input
                      className="nfe-input form-control"
                      type="text"
                      value={pesol}
                      onChange={(e) => setPesol(e.target.value)}
                    />
                  </Col>
                  <Col md={2}>
                    <label className="nfe-label">Peso Bruto (kg)</label>
                    <input
                      className="nfe-input form-control"
                      type="text"
                      value={pesob}
                      onChange={(e) => setPesob(e.target.value)}
                    />
                  </Col>
                  <Col md={4}>
                    <label className="nfe-label">
                      CPF / CNPJ do Transportador
                    </label>
                    <input
                      disabled
                      className="nfe-input form-control"
                      type="text"
                      value={cnpjTransp}
                    />
                  </Col>

                  <Col md={8}>
                    <label className="nfe-label">Transportador</label>
                    <div style={{ position: 'relative' }}>
                      <div style={{ display: 'flex', gap: 4 }}>
                        <input
                          ref={transpInputRef}
                          type="text"
                          className="nfe-input form-control"
                          placeholder="Nome do transportador..."
                          value={nomeTransp || ''}
                          onFocus={() =>
                            setTranspRect(
                              transpInputRef.current?.getBoundingClientRect(),
                            )
                          }
                          onChange={(e) => {
                            const v = e.target.value
                            setNomeTransp(v)
                            setTranspRect(
                              transpInputRef.current?.getBoundingClientRect(),
                            )
                            if (v.length >= 3) handleSearchtTransp()
                            else setSearchResultsTrans([])
                          }}
                        />
                        {/* ── Botão limpar transportador ── */}
                        {(nomeTransp || idtransp) && (
                          <button
                            type="button"
                            onClick={() => {
                              setNomeTransp('')
                              setCnpjTransp('')
                              setIdTransp(null)
                              setSearchResultsTrans([])
                            }}
                            style={{
                              height: 34,
                              width: 34,
                              flexShrink: 0,
                              border: '1px solid #d4d4d8',
                              borderRadius: 6,
                              background: '#fff',
                              color: '#9ca3af',
                              cursor: 'pointer',
                              fontSize: 16,
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              transition: 'all 0.12s',
                            }}
                            onMouseEnter={(e) => {
                              e.currentTarget.style.background = '#fee2e2'
                              e.currentTarget.style.color = '#dc2626'
                              e.currentTarget.style.borderColor = '#fca5a5'
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.background = '#fff'
                              e.currentTarget.style.color = '#9ca3af'
                              e.currentTarget.style.borderColor = '#d4d4d8'
                            }}
                            title="Remover transportador"
                          >
                            ×
                          </button>
                        )}
                      </div>

                      {searchResultsTrans.length > 0 &&
                        transpRect &&
                        (nomeTransp?.length ?? 0) >= 3 && (
                          <div
                            style={{
                              position: 'fixed',
                              top: transpRect.bottom + 2,
                              left: transpRect.left,
                              width: transpRect.width,
                              background: '#fff',
                              border: '1px solid #e5e7eb',
                              borderRadius: 8,
                              boxShadow: '0 8px 24px rgba(0,0,0,.12)',
                              zIndex: 9999,
                              maxHeight: 220,
                              overflowY: 'auto',
                            }}
                          >
                            <table
                              style={{
                                width: '100%',
                                fontSize: 12,
                                borderCollapse: 'collapse',
                              }}
                            >
                              <thead>
                                <tr style={{ background: '#f8fafc' }}>
                                  <th style={{ padding: '6px 10px' }}>CNPJ</th>
                                  <th style={{ padding: '6px 10px' }}>
                                    Razão Social
                                  </th>
                                  <th style={{ padding: '6px 10px' }}>Cód.</th>
                                </tr>
                              </thead>
                              <tbody>
                                {searchResultsTrans.map((r) => (
                                  <tr
                                    key={r.cod_pessoa}
                                    onClick={() => {
                                      handleSelectTransp(r)
                                      setSearchResultsTrans([])
                                    }}
                                    style={{
                                      cursor: 'pointer',
                                      borderBottom: '1px solid #f3f4f6',
                                    }}
                                    onMouseEnter={(e) =>
                                      (e.currentTarget.style.background =
                                        '#eff6ff')
                                    }
                                    onMouseLeave={(e) =>
                                      (e.currentTarget.style.background =
                                        '#fff')
                                    }
                                  >
                                    <td style={{ padding: '6px 10px' }}>
                                      {r.pes_cnpj_cpf}
                                    </td>
                                    <td style={{ padding: '6px 10px' }}>
                                      {r.pes_razao}
                                    </td>
                                    <td style={{ padding: '6px 10px' }}>
                                      {r.cod_pessoa}
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        )}
                    </div>
                  </Col>
                </Row>
              </SectionBody>
            </SectionCard>

            {/* ══════════════════════════════════════════════════════════════════
                SEÇÃO 5 — INFORMAÇÕES ADICIONAIS + PARCELAS
            ══════════════════════════════════════════════════════════════════ */}
            <SectionCard>
              <SectionHeader>
                <span className="badge-section">05</span>
                <h3>Informações Adicionais e Parcelas</h3>
              </SectionHeader>
              <SectionBody>
                <label className="nfe-label">Observações / Complemento</label>
                <textarea
                  className="nfe-textarea form-control"
                  rows={3}
                  placeholder="Informações complementares..."
                  value={observacaoInterna}
                  onChange={(e) => setObservacaoInterna(e.target.value)}
                  style={{ marginBottom: 20 }}
                />

                <div
                  style={{
                    display: 'flex',
                    gap: 10,
                    alignItems: 'flex-end',
                    marginBottom: 16,
                  }}
                >
                  <div style={{ flex: 1 }}>
                    <label className="nfe-label">
                      Dias para Parcelas (separados por vírgula)
                    </label>
                    <input
                      className="nfe-input form-control"
                      type="text"
                      placeholder="Ex: 30, 60, 90"
                      value={diasParcelas}
                      onChange={(e) => setDiasParcelas(e.target.value)}
                    />
                  </div>
                  <button
                    type="button"
                    className="btn btn-primary btn-sm"
                    style={{
                      height: 34,
                      borderRadius: 6,
                      fontWeight: 600,
                      fontSize: 12,
                      padding: '0 16px',
                    }}
                    onClick={calcularParcelas}
                  >
                    Calcular
                  </button>
                </div>

                {parcelas.length > 0 && (
                  <div
                    style={{
                      borderRadius: 8,
                      border: '1px solid #e5e7eb',
                      overflow: 'hidden',
                    }}
                  >
                    <table
                      style={{
                        width: '100%',
                        borderCollapse: 'collapse',
                        fontSize: 12,
                      }}
                    >
                      <thead>
                        <tr style={{ background: '#f4f4f5', color: '#52525b' }}>
                          <th
                            style={{
                              padding: '8px 12px',
                              fontWeight: 600,
                              fontSize: 10,
                              letterSpacing: 1,
                              textTransform: 'uppercase',
                            }}
                          >
                            Parcela
                          </th>
                          <th
                            style={{
                              padding: '8px 12px',
                              fontWeight: 600,
                              fontSize: 10,
                              letterSpacing: 1,
                              textTransform: 'uppercase',
                            }}
                          >
                            Vencimento
                          </th>
                          <th
                            style={{
                              padding: '8px 12px',
                              fontWeight: 600,
                              fontSize: 10,
                              letterSpacing: 1,
                              textTransform: 'uppercase',
                            }}
                          >
                            Valor
                          </th>
                          <th
                            style={{
                              padding: '8px 12px',
                              fontWeight: 600,
                              fontSize: 10,
                              letterSpacing: 1,
                              textTransform: 'uppercase',
                            }}
                          >
                            Anotações
                          </th>
                          <th
                            style={{
                              padding: '8px 12px',
                              fontWeight: 600,
                              fontSize: 10,
                              letterSpacing: 1,
                              textTransform: 'uppercase',
                            }}
                          >
                            Ações
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {parcelas.map((p) => (
                          <tr
                            key={p.codigo}
                            style={{ borderBottom: '1px solid #e5e7eb' }}
                          >
                            <td style={{ padding: '8px 12px' }}>
                              {p.num_parcela}
                            </td>
                            <td style={{ padding: '8px 12px' }}>
                              {p.data
                                ? format(new Date(p.data), 'dd/MM/yyyy')
                                : ''}
                            </td>
                            <td style={{ padding: '8px 12px' }}>
                              <input
                                type="text"
                                className="nfe-input form-control"
                                style={{ width: 100, height: 30 }}
                                value={
                                  p.valor === null
                                    ? ''
                                    : p.valor.toLocaleString('pt-BR', {
                                        style: 'currency',
                                        currency: 'BRL',
                                      })
                                }
                                onChange={(e) =>
                                  handeleditarValor(
                                    p.num_parcela,
                                    e.target.value
                                      .replace(/[^\d.,]/g, '')
                                      .replace(',', '.'),
                                  )
                                }
                              />
                            </td>
                            <td style={{ padding: '8px 12px' }}>
                              <input
                                type="text"
                                className="nfe-input form-control"
                                style={{ height: 30 }}
                                value={p.obs}
                                onChange={(e) =>
                                  handleEditarObservacao(
                                    p.num_parcela,
                                    e.target.value,
                                  )
                                }
                              />
                            </td>
                            <td style={{ padding: '8px 12px' }}>
                              <button
                                type="button"
                                onClick={() => handleExcluirParcela(p.codigo)}
                                style={{
                                  background: '#ef4444',
                                  color: '#fff',
                                  border: 'none',
                                  borderRadius: 6,
                                  padding: '4px 10px',
                                  cursor: 'pointer',
                                  fontSize: 11,
                                }}
                              >
                                Excluir
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </SectionBody>
            </SectionCard>
          </Form>
        </div>

        {/* ══════════════════════════════════════════════════════════════════════
            MODAL — DADOS DO CLIENTE
        ══════════════════════════════════════════════════════════════════════ */}
        <Modal
          show={showAddressModal}
          onHide={() => setShowAddressModal(false)}
          dialogClassName="custom-modalzpl"
        >
          <form onSubmit={HandleCadastrarCliente}>
            <Modal.Header
              style={{ background: '#fff', borderBottom: '1px solid #e4e4e7' }}
            >
              <Modal.Title style={{ color: '#18181b', fontSize: 15 }}>
                Dados do Cliente
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="row g-3">
                <div className="col-md-2">
                  <label className="nfe-label">Tipo</label>
                  <select
                    className="nfe-select form-control"
                    value={endereco.pes_tipo}
                    onChange={(e) =>
                      setEndereco({ ...endereco, pes_tipo: e.target.value })
                    }
                  >
                    <option value="F">Pessoa Física</option>
                    <option value="J">Pessoa Jurídica</option>
                  </select>
                </div>
                <div className="col-md-2">
                  <label className="nfe-label">Contribuinte</label>
                  <select
                    className="nfe-select form-control"
                    value={endereco.cod_tipo_contribuinte}
                    onChange={(e) =>
                      setEndereco({
                        ...endereco,
                        cod_tipo_contribuinte: e.target.value,
                      })
                    }
                  >
                    <option value="1">CONTRIBUINTE ICMS</option>
                    <option value="2">CONTRIBUINTE ISENTO</option>
                    <option value="9">NAO CONTRIBUINTE</option>
                    <option value="99">NAO SELECIONADO</option>
                  </select>
                </div>
                <div className="col-md-6">
                  <label className="nfe-label">
                    {endereco.pes_tipo === 'F' ? 'Nome' : 'Empresa'}
                  </label>
                  <input
                    required
                    type="text"
                    className="nfe-input form-control"
                    value={endereco.pes_razao}
                    onChange={(e) =>
                      setEndereco({ ...endereco, pes_razao: e.target.value })
                    }
                  />
                </div>
                <div className="col-md-4">
                  <label className="nfe-label">
                    {endereco.pes_tipo === 'F' ? 'CPF' : 'CNPJ'}
                  </label>
                  <ReactInputMask
                    mask={
                      endereco.pes_tipo === 'F'
                        ? '999.999.999-99'
                        : '99.999.999/9999-99'
                    }
                    maskChar={null}
                    value={endereco.pes_cnpj_cpf}
                    onChange={(e) =>
                      setEndereco({
                        ...endereco,
                        pes_cnpj_cpf: e.target.value.replace(/[^0-9]/g, ''),
                      })
                    }
                    className="nfe-input form-control"
                  />
                </div>
                <div className="col-md-4">
                  <label className="nfe-label">
                    {endereco.pes_tipo === 'F' ? 'RG' : 'Insc. Estadual'}
                  </label>
                  <input
                    value={endereco.pes_insc_estadual}
                    onChange={(e) =>
                      setEndereco({
                        ...endereco,
                        pes_insc_estadual: e.target.value,
                      })
                    }
                    className="nfe-input form-control"
                  />
                </div>
                <div className="col-md-3">
                  <label className="nfe-label">CEP</label>
                  <input
                    type="text"
                    className="nfe-input form-control"
                    id="cep"
                    value={endereco.pes_cep}
                    onChange={(e) =>
                      setEndereco({ ...endereco, pes_cep: e.target.value })
                    }
                    onBlur={buscaCep}
                  />
                </div>
                <div className="col-md-6">
                  <label className="nfe-label">Logradouro</label>
                  <input
                    type="text"
                    className="nfe-input form-control"
                    value={endereco.pes_logradouro}
                    onChange={(e) =>
                      setEndereco({
                        ...endereco,
                        pes_logradouro: e.target.value,
                      })
                    }
                  />
                </div>
                <div className="col-md-6">
                  <label className="nfe-label">Bairro</label>
                  <input
                    type="text"
                    className="nfe-input form-control"
                    value={endereco.pes_bairro}
                    onChange={(e) =>
                      setEndereco({ ...endereco, pes_bairro: e.target.value })
                    }
                  />
                </div>
                <div className="col-md-2">
                  <label className="nfe-label">Número</label>
                  <input
                    type="text"
                    className="nfe-input form-control"
                    value={endereco.pes_numero}
                    onChange={(e) =>
                      setEndereco({ ...endereco, pes_numero: e.target.value })
                    }
                  />
                </div>
                <div className="col-md-4">
                  <label className="nfe-label">Cidade</label>
                  <input
                    type="text"
                    className="nfe-input form-control"
                    value={endereco.pes_cidade}
                    onChange={(e) =>
                      setEndereco({ ...endereco, pes_cidade: e.target.value })
                    }
                  />
                </div>
                <div className="col-md-2">
                  <label className="nfe-label">Estado</label>
                  <input
                    type="text"
                    className="nfe-input form-control"
                    value={endereco.pes_uf}
                    onChange={(e) =>
                      setEndereco({ ...endereco, pes_uf: e.target.value })
                    }
                  />
                </div>
                <div className="col-md-2">
                  <label className="nfe-label">IBGE</label>
                  <input
                    type="text"
                    className="nfe-input form-control"
                    value={endereco.pes_ibge}
                    onChange={(e) =>
                      setEndereco({ ...endereco, pes_ibge: e.target.value })
                    }
                  />
                </div>
                <div className="col-md-2">
                  <label className="nfe-label">Telefone</label>
                  <input
                    type="text"
                    className="nfe-input form-control"
                    value={endereco.pes_telefone}
                    onChange={(e) =>
                      setEndereco({ ...endereco, pes_telefone: e.target.value })
                    }
                  />
                </div>
                <div className="col-md-6">
                  <label className="nfe-label">Celular</label>
                  <InputMask
                    mask="(99) 99999-9999"
                    maskChar="_"
                    className="nfe-input form-control"
                    value={endereco.pes_celular}
                    onChange={(e) =>
                      setEndereco({ ...endereco, pes_celular: e.target.value })
                    }
                  />
                </div>
              </div>
            </Modal.Body>
            <Modal.Footer style={{ background: '#f8fafc' }}>
              <Button
                variant="success"
                type="submit"
                style={{ fontWeight: 600, fontSize: 13 }}
              >
                Cadastrar / Editar
              </Button>
              <Button
                variant="secondary"
                onClick={() => setShowAddressModal(false)}
                style={{ fontSize: 13 }}
              >
                Fechar
              </Button>
            </Modal.Footer>
          </form>
        </Modal>

        {/* ══════════════════════════════════════════════════════════════════════
            MODAL — EDIÇÃO DE ITEM
        ══════════════════════════════════════════════════════════════════════ */}
        <Modal
          show={showModal}
          onHide={() => setShowModal(false)}
          dialogClassName="custom-modalzpl"
        >
          <Form onSubmit={addNFeItensArray}>
            <Modal.Header
              style={{ background: '#fff', borderBottom: '1px solid #e4e4e7' }}
            >
              <Modal.Title style={{ color: '#18181b', fontSize: 15 }}>
                Editar Item
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {editedItem && (
                <>
                  {/* Descrição */}
                  <div style={{ marginBottom: 14 }}>
                    <label className="nfe-label">Descrição do Produto</label>
                    <div style={{ position: 'relative' }}>
                      <input
                        required
                        type="text"
                        className="nfe-input form-control"
                        placeholder="Descrição ou SKU..."
                        autoComplete="off"
                        value={editedItem.descricao}
                        onChange={(e) => {
                          const v = e.target.value
                          setEditedItem({ ...editedItem, descricao: v })
                          handleSearchWithTimeout(v)
                        }}
                      />
                      {searchResultsProd.length > 0 && (
                        <div
                          style={{
                            position: 'absolute',
                            top: '100%',
                            left: 0,
                            width: '100%',
                            maxHeight: 200,
                            overflowY: 'auto',
                            border: '1px solid #e5e7eb',
                            borderRadius: 8,
                            boxShadow: '0 4px 12px rgba(0,0,0,.1)',
                            background: '#fff',
                            zIndex: 999,
                          }}
                        >
                          <table
                            style={{
                              width: '100%',
                              borderCollapse: 'collapse',
                              fontSize: 12,
                            }}
                          >
                            <thead>
                              <tr style={{ background: '#f8fafc' }}>
                                <th style={{ padding: '6px 10px' }}>SKU</th>
                                <th style={{ padding: '6px 10px' }}>
                                  Descrição
                                </th>
                                <th style={{ padding: '6px 10px' }}>Preço</th>
                              </tr>
                            </thead>
                            <tbody>
                              {searchResultsProd.map((r) => (
                                <tr
                                  key={r.CODPRODUTO}
                                  onClick={() => {
                                    handleSelect(r)
                                    setSearchResults([])
                                  }}
                                  style={{
                                    cursor: 'pointer',
                                    borderBottom: '1px solid #f3f4f6',
                                  }}
                                  onMouseEnter={(e) =>
                                    (e.currentTarget.style.background =
                                      '#eff6ff')
                                  }
                                  onMouseLeave={(e) =>
                                    (e.currentTarget.style.background = '#fff')
                                  }
                                >
                                  <td style={{ padding: '6px 10px' }}>
                                    {r.SKU}
                                  </td>
                                  <td style={{ padding: '6px 10px' }}>
                                    {r.DESCRICAO}
                                  </td>
                                  <td style={{ padding: '6px 10px' }}>
                                    {r.PRECOVENDA?.toFixed(2) || 0}
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      )}
                    </div>
                  </div>

                  {/* Qtde / Valor / Desconto / Total */}
                  <Row className="g-2 mb-3">
                    <Col>
                      <label className="nfe-label">Qtde</label>
                      <input
                        required
                        className="nfe-input form-control"
                        type="text"
                        onBlur={alternarItems}
                        value={(editedItem.qtde || 1)
                          .toString()
                          .replace(',', '.')}
                        onChange={(e) =>
                          setEditedItem({ ...editedItem, qtde: e.target.value })
                        }
                      />
                    </Col>
                    <Col>
                      <label className="nfe-label">Vl. Unitário</label>
                      <input
                        className="nfe-input form-control"
                        type="text"
                        value={(editedItem.valorunitario || 0)
                          .toString()
                          .replace(',', '.')}
                        onChange={(e) =>
                          setEditedItem({
                            ...editedItem,
                            valorunitario: e.target.value.replace(',', '.'),
                          })
                        }
                      />
                    </Col>
                    <Col>
                      <label className="nfe-label">Desconto (R$)</label>
                      <input
                        className="nfe-input form-control"
                        type="text"
                        value={editedItem.desconto || ''}
                        onChange={(e) =>
                          setEditedItem({
                            ...editedItem,
                            desconto: e.target.value,
                          })
                        }
                      />
                    </Col>
                    <Col>
                      <label className="nfe-label">Total</label>
                      <input
                        disabled
                        className="nfe-input form-control"
                        id="formValorTotalLiquido"
                        type="text"
                        value={(
                          editedItem.valorunitario * editedItem.qtde || 0
                        ).toFixed(2)}
                      />
                    </Col>
                  </Row>

                  {/* NCM / Unidade / SKU */}
                  <Row className="g-2 mb-3">
                    <Col md={4}>
                      <label className="nfe-label">NCM</label>
                      <input
                        className="nfe-input form-control"
                        type="text"
                        value={editedItem.ncm || ''}
                        onChange={(e) =>
                          setEditedItem({ ...editedItem, ncm: e.target.value })
                        }
                      />
                    </Col>
                    <Col md={4}>
                      <label className="nfe-label">Unidade</label>
                      <input
                        className="nfe-input form-control"
                        type="text"
                        value={editedItem.unidade || ''}
                        onChange={(e) =>
                          setEditedItem({
                            ...editedItem,
                            unidade: e.target.value,
                          })
                        }
                      />
                    </Col>
                    <Col md={4}>
                      <label className="nfe-label">SKU</label>
                      <input
                        className="nfe-input form-control"
                        type="text"
                        value={editedItem.sku || ''}
                        onChange={(e) =>
                          setEditedItem({ ...editedItem, sku: e.target.value })
                        }
                      />
                    </Col>
                  </Row>

                  {/* Calcular BC/ICMS */}
                  <div
                    style={{
                      margin: '8px 0 14px',
                      display: 'flex',
                      alignItems: 'center',
                      gap: 10,
                      background: '#f0fdf4',
                      border: '1px solid #bbf7d0',
                      borderRadius: 8,
                      padding: '8px 14px',
                    }}
                  >
                    <span style={{ fontSize: 12, color: '#166534', flex: 1 }}>
                      <strong>Calcular BC/ICMS</strong> — UF:{' '}
                      <strong>{(uf || '—').toUpperCase()}</strong>
                      {' | '}
                      {tipoDestinatario === 'F'
                        ? 'Pessoa Física'
                        : 'Pessoa Jurídica'}
                      {' | '}
                      {tipoContribuinteDestinatario === '1'
                        ? 'Contribuinte'
                        : 'Não Contribuinte'}
                      {String(editedItem.csticms) === '20' && (
                        <span
                          style={{
                            marginLeft: 8,
                            background: '#fef3c7',
                            color: '#92400e',
                            padding: '1px 6px',
                            borderRadius: 4,
                            fontSize: 10,
                          }}
                        >
                          CST 60 — sem BC
                        </span>
                      )}
                    </span>
                    <Button
                      variant="success"
                      size="sm"
                      type="button"
                      style={{
                        whiteSpace: 'nowrap',
                        fontSize: 12,
                        borderRadius: 7,
                      }}
                      onClick={calcularICMS}
                    >
                      ⚡ Calcular
                    </Button>
                  </div>

                  {/* ICMS */}
                  <div
                    style={{
                      background: '#f8fafc',
                      borderRadius: 8,
                      padding: '12px 14px',
                      marginBottom: 12,
                    }}
                  >
                    <p
                      style={{
                        fontSize: 10,
                        fontWeight: 700,
                        color: '#6b7280',
                        marginBottom: 10,
                        letterSpacing: 1,
                        textTransform: 'uppercase',
                      }}
                    >
                      ICMS
                    </p>
                    <Row className="g-2">
                      <Col md={3}>
                        <label className="nfe-label">CST ICMS</label>
                        <select
                          className="nfe-select form-control"
                          value={String(editedItem.csticms || '')}
                          onChange={(e) =>
                            setEditedItem({
                              ...editedItem,
                              csticms: e.target.value,
                            })
                          }
                          style={{ fontSize: 11 }}
                        >
                          <option value="">-- CST --</option>
                          {CST_CSOSN_OPTIONS.filter(
                            (o) => o.tipo === 'CST',
                          ).map((o) => (
                            <option
                              key={o.id}
                              value={String(o.id)}
                            >
                              {o.codigo} – {o.descricao}
                            </option>
                          ))}
                        </select>
                      </Col>
                      <Col md={3}>
                        <label className="nfe-label">CSOSN</label>
                        <select
                          className="nfe-select form-control"
                          value={String(editedItem.csosn || '')}
                          onChange={(e) =>
                            setEditedItem({
                              ...editedItem,
                              csosn: e.target.value,
                            })
                          }
                          style={{ fontSize: 11 }}
                        >
                          <option value="">-- CSOSN --</option>
                          {CST_CSOSN_OPTIONS.filter(
                            (o) => o.tipo === 'CSOSN',
                          ).map((o) => (
                            <option
                              key={o.id}
                              value={String(o.id)}
                            >
                              {o.codigo} – {o.descricao}
                            </option>
                          ))}
                        </select>
                      </Col>
                      <Col md={3}>
                        <label className="nfe-label">CFOP</label>
                        <div style={{ position: 'relative' }}>
                          <input
                            type="text"
                            className="nfe-input form-control"
                            placeholder="Ex: 6102"
                            autoComplete="off"
                            value={editedItem.cfop || ''}
                            onChange={(e) => {
                              const v = e.target.value
                              setEditedItem({ ...editedItem, cfop: v })
                              setCfopSearch(v)
                              setShowCfopDropdown(v.length >= 1)
                            }}
                            onFocus={() => setShowCfopDropdown(true)}
                            onBlur={() =>
                              setTimeout(() => setShowCfopDropdown(false), 200)
                            }
                          />
                          {editedItem.cfop &&
                            (() => {
                              const found = CFOP_OPTIONS.find(
                                (c) => c.codigo === String(editedItem.cfop),
                              )
                              return found ? (
                                <div
                                  style={{
                                    fontSize: 10,
                                    color: '#059669',
                                    marginTop: 2,
                                    fontWeight: 500,
                                  }}
                                >
                                  ✓ {found.tipo}
                                </div>
                              ) : (
                                <div
                                  style={{
                                    fontSize: 10,
                                    color: '#9ca3af',
                                    marginTop: 2,
                                  }}
                                >
                                  CFOP não encontrado
                                </div>
                              )
                            })()}
                          {showCfopDropdown && (
                            <div
                              style={{
                                position: 'absolute',
                                top: '100%',
                                left: 0,
                                width: '340px',
                                maxHeight: 220,
                                overflowY: 'auto',
                                border: '1px solid #e5e7eb',
                                borderRadius: 8,
                                background: '#fff',
                                zIndex: 1050,
                                boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                              }}
                            >
                              {CFOP_OPTIONS.filter(
                                (c) =>
                                  c.codigo.includes(cfopSearch) ||
                                  c.descricao
                                    .toLowerCase()
                                    .includes(cfopSearch.toLowerCase()),
                              ).map((c) => (
                                <div
                                  key={c.codigo}
                                  onMouseDown={() => {
                                    setEditedItem({
                                      ...editedItem,
                                      cfop: c.codigo,
                                    })
                                    setCfopSearch(c.codigo)
                                    setShowCfopDropdown(false)
                                  }}
                                  style={{
                                    padding: '7px 12px',
                                    cursor: 'pointer',
                                    borderBottom: '1px solid #f3f4f6',
                                    fontSize: 12,
                                  }}
                                  onMouseEnter={(e) =>
                                    (e.currentTarget.style.background =
                                      '#f0fdf4')
                                  }
                                  onMouseLeave={(e) =>
                                    (e.currentTarget.style.background = '#fff')
                                  }
                                >
                                  <span
                                    style={{ fontWeight: 700, marginRight: 8 }}
                                  >
                                    {c.codigo}
                                  </span>
                                  <span
                                    style={{
                                      fontSize: 10,
                                      padding: '1px 6px',
                                      borderRadius: 10,
                                      background: c.tipo.includes('Saída')
                                        ? '#dbeafe'
                                        : '#fef3c7',
                                      color: c.tipo.includes('Saída')
                                        ? '#1d4ed8'
                                        : '#92400e',
                                      marginRight: 6,
                                    }}
                                  >
                                    {c.tipo}
                                  </span>
                                  <span
                                    style={{ color: '#6b7280', fontSize: 11 }}
                                  >
                                    {c.descricao}
                                  </span>
                                </div>
                              ))}
                            </div>
                          )}
                        </div>
                      </Col>
                      <Col md={3}>
                        <label className="nfe-label">BC ICMS</label>
                        <div style={{ display: 'flex', gap: 4 }}>
                          <input
                            type="text"
                            className="nfe-input form-control"
                            placeholder="BC ICMS"
                            value={editedItem.bcicms || ''}
                            onBlur={handleBCicms}
                            onChange={(e) =>
                              setEditedItem({
                                ...editedItem,
                                bcicms: e.target.value,
                              })
                            }
                          />
                          <button
                            type="button"
                            style={{
                              height: 36,
                              padding: '0 10px',
                              background: '#f3f4f6',
                              border: '1.5px solid #e5e7eb',
                              borderRadius: 8,
                              cursor: 'pointer',
                              fontSize: 14,
                              color: '#6b7280',
                            }}
                            onClick={() =>
                              setEditedItem({
                                ...editedItem,
                                bcicms: '',
                                porcicms: '',
                                valoricms: '',
                              })
                            }
                          >
                            ✕
                          </button>
                        </div>
                      </Col>
                      <Col md={4}>
                        <label className="nfe-label">
                          % ICMS (interestadual)
                        </label>
                        <input
                          type="text"
                          className="nfe-input form-control"
                          placeholder="% ICMS"
                          value={editedItem.porcicms || ''}
                          onChange={(e) =>
                            setEditedItem({
                              ...editedItem,
                              porcicms: e.target.value,
                            })
                          }
                        />
                      </Col>
                      <Col md={4}>
                        <label className="nfe-label">Valor ICMS</label>
                        <input
                          disabled
                          type="text"
                          className="nfe-input form-control"
                          value={
                            editedItem.porcicms && editedItem.bcicms
                              ? (
                                  (parseFloat(editedItem.bcicms) *
                                    parseFloat(editedItem.porcicms)) /
                                  100
                                ).toFixed(2)
                              : editedItem.valoricms || ''
                          }
                        />
                      </Col>
                      <Col md={4}>
                        <label className="nfe-label">
                          % ICMS Estadual SP (DIFAL)
                        </label>
                        <input
                          type="text"
                          className="nfe-input form-control"
                          placeholder="18 (SP fixo)"
                          value={editedItem.porcicmsest || ''}
                          onChange={(e) =>
                            setEditedItem({
                              ...editedItem,
                              porcicmsest: e.target.value,
                            })
                          }
                        />
                        {editedItem.porcicmsest && editedItem.porcicms && (
                          <div
                            style={{
                              fontSize: 10,
                              color: '#2563eb',
                              marginTop: 3,
                            }}
                          >
                            DIFAL:{' '}
                            {(
                              parseFloat(editedItem.porcicmsest) -
                              parseFloat(editedItem.porcicms)
                            ).toFixed(2)}
                            %
                          </div>
                        )}
                      </Col>
                    </Row>
                  </div>

                  {/* IPI */}
                  <div
                    style={{
                      background: '#f8fafc',
                      borderRadius: 8,
                      padding: '12px 14px',
                      marginBottom: 12,
                    }}
                  >
                    <p
                      style={{
                        fontSize: 10,
                        fontWeight: 700,
                        color: '#6b7280',
                        marginBottom: 10,
                        letterSpacing: 1,
                        textTransform: 'uppercase',
                      }}
                    >
                      IPI
                    </p>
                    <Row className="g-2">
                      <Col md={4}>
                        <label className="nfe-label">% IPI</label>
                        <input
                          type="text"
                          className="nfe-input form-control"
                          value={editedItem.porcipi || ''}
                          onChange={(e) =>
                            setEditedItem({
                              ...editedItem,
                              porcipi: e.target.value,
                            })
                          }
                        />
                      </Col>
                      <Col md={4}>
                        <label className="nfe-label">Valor IPI</label>
                        <input
                          disabled
                          type="text"
                          className="nfe-input form-control"
                          value={
                            editedItem.porcipi && editedItem.valortotalliquido
                              ? (
                                  (parseFloat(editedItem.valortotalliquido) *
                                    parseFloat(editedItem.porcipi)) /
                                  100
                                ).toFixed(2)
                              : editedItem.valoripi || ''
                          }
                        />
                      </Col>
                    </Row>
                  </div>

                  {/* ICMS ST */}
                  <div
                    style={{
                      background: '#f8fafc',
                      borderRadius: 8,
                      padding: '12px 14px',
                    }}
                  >
                    <p
                      style={{
                        fontSize: 10,
                        fontWeight: 700,
                        color: '#6b7280',
                        marginBottom: 10,
                        letterSpacing: 1,
                        textTransform: 'uppercase',
                      }}
                    >
                      ICMS ST
                    </p>
                    <Row className="g-2">
                      <Col md={4}>
                        <label className="nfe-label">BC ICMS ST</label>
                        <input
                          type="text"
                          className="nfe-input form-control"
                          value={editedItem.bcicmsst || ''}
                          onChange={(e) =>
                            setEditedItem({
                              ...editedItem,
                              bcicmsst: e.target.value,
                            })
                          }
                        />
                      </Col>
                      <Col md={4}>
                        <label className="nfe-label">Valor ICMS ST</label>
                        <input
                          type="text"
                          className="nfe-input form-control"
                          value={editedItem.valoricmsst || ''}
                          onChange={(e) =>
                            setEditedItem({
                              ...editedItem,
                              valoricmsst: e.target.value,
                            })
                          }
                        />
                      </Col>
                    </Row>
                  </div>
                </>
              )}
            </Modal.Body>
            <Modal.Footer style={{ background: '#f8fafc' }}>
              <Button
                variant="secondary"
                onClick={() => setShowModal(false)}
                style={{ fontSize: 13 }}
              >
                Fechar
              </Button>
              <Button
                variant="primary"
                type="submit"
                style={{ fontWeight: 600, fontSize: 13 }}
              >
                Salvar Alterações
              </Button>
            </Modal.Footer>
          </Form>
        </Modal>

        {/* ══════════════════════════════════════════════════════════════════════
            MODAL — TRANSMISSÃO (timeline)
        ══════════════════════════════════════════════════════════════════════ */}
        <Modal
          show={showModalTrans}
          onHide={() => !transmitting && setShowModalTrans(false)}
          centered
        >
          <Modal.Header
            closeButton={!transmitting}
            style={{ background: '#fff', borderBottom: '1px solid #e4e4e7' }}
          >
            <Modal.Title style={{ color: '#18181b', fontSize: 15 }}>
              {transmitting ? (
                <>
                  <FontAwesomeIcon
                    icon={faSpinner}
                    spin
                    style={{ marginRight: 8, color: '#2563eb' }}
                  />
                  Emitindo NF-e...
                </>
              ) : emissaoSteps.some((s) => s.status === 'error') ? (
                <>
                  <FontAwesomeIcon
                    icon={faTimes}
                    style={{ marginRight: 8, color: '#ef4444' }}
                  />
                  Erro na Emissão
                </>
              ) : (
                <>
                  <FontAwesomeIcon
                    icon={faCheck}
                    style={{ marginRight: 8, color: '#22c55e' }}
                  />
                  Emissão Concluída
                </>
              )}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body style={{ padding: '20px 24px' }}>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 0 }}>
              {emissaoSteps.map((step, idx) => {
                const isLast = idx === emissaoSteps.length - 1
                const icon =
                  step.status === 'loading' ? (
                    <FontAwesomeIcon
                      icon={faSpinner}
                      spin
                      style={{ color: '#2563eb' }}
                    />
                  ) : step.status === 'success' ? (
                    <FontAwesomeIcon
                      icon={faCheck}
                      style={{ color: '#22c55e' }}
                    />
                  ) : step.status === 'error' ? (
                    <FontAwesomeIcon
                      icon={faTimes}
                      style={{ color: '#ef4444' }}
                    />
                  ) : (
                    <span style={{ color: '#f59e0b', fontWeight: 'bold' }}>
                      ⚠
                    </span>
                  )
                const lineColor =
                  step.status === 'success'
                    ? '#22c55e'
                    : step.status === 'error'
                      ? '#ef4444'
                      : step.status === 'warning'
                        ? '#f59e0b'
                        : '#d4d4d8'
                return (
                  <div
                    key={step.id}
                    style={{ display: 'flex', gap: 12 }}
                  >
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        width: 28,
                      }}
                    >
                      <div
                        style={{
                          width: 28,
                          height: 28,
                          borderRadius: '50%',
                          background:
                            step.status === 'loading'
                              ? '#dbeafe'
                              : step.status === 'success'
                                ? '#dcfce7'
                                : step.status === 'error'
                                  ? '#fee2e2'
                                  : '#fef9c3',
                          border: `2px solid ${lineColor}`,
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          fontSize: 12,
                          flexShrink: 0,
                        }}
                      >
                        {icon}
                      </div>
                      {!isLast && (
                        <div
                          style={{
                            width: 2,
                            flex: 1,
                            minHeight: 20,
                            background: lineColor,
                            margin: '2px 0',
                            transition: 'background 0.3s',
                          }}
                        />
                      )}
                    </div>
                    <div
                      style={{
                        paddingBottom: isLast ? 0 : 16,
                        paddingTop: 4,
                        flex: 1,
                      }}
                    >
                      <div
                        style={{
                          fontSize: 13,
                          fontWeight: 600,
                          color:
                            step.status === 'error'
                              ? '#dc2626'
                              : step.status === 'success'
                                ? '#16a34a'
                                : step.status === 'warning'
                                  ? '#d97706'
                                  : '#2563eb',
                        }}
                      >
                        {step.label}
                      </div>
                      {step.detail && (
                        <div
                          style={{
                            fontSize: 11,
                            color: '#9ca3af',
                            marginTop: 2,
                            background: '#f4f4f5',
                            borderRadius: 4,
                            padding: '3px 8px',
                            borderLeft: `3px solid ${lineColor}`,
                            maxHeight: 60,
                            overflowY: 'auto',
                          }}
                        >
                          {step.detail}
                        </div>
                      )}
                    </div>
                  </div>
                )
              })}
              {emissaoSteps.length === 0 && (
                <div
                  style={{
                    textAlign: 'center',
                    color: '#71717a',
                    fontSize: 13,
                    padding: '20px 0',
                  }}
                >
                  <FontAwesomeIcon
                    icon={faSpinner}
                    spin
                    style={{ marginRight: 8 }}
                  />{' '}
                  Iniciando processo...
                </div>
              )}
            </div>
          </Modal.Body>
          {!transmitting && (
            <Modal.Footer
              style={{ background: '#f9f9f9', borderTop: '1px solid #e4e4e7' }}
            >
              <Button
                variant="secondary"
                size="sm"
                onClick={() => setShowModalTrans(false)}
                style={{ fontSize: 12 }}
              >
                Fechar
              </Button>
            </Modal.Footer>
          )}
        </Modal>

        {/* ── Barra de ações fixada no rodapé ── */}
        <ActionBar>
          <CustomButton
            title="Gravar"
            onClick={handleGravarNFe}
            isLoading={isGravarNfeLoading}
            isLoadingText="Gravando..."
          >
            <FloppyDisk
              size={20}
              weight="fill"
            />
          </CustomButton>
          <CustomButton
            title="Consultar"
            onClick={() => handleConsultarStatus(idnfe, emp_conta)}
            isLoading={isConsultarLoading}
            isLoadingText="Consultando..."
            color="#2B2D42"
          >
            <Info
              size={20}
              weight="fill"
            />
          </CustomButton>
          <CustomButton
            title="Validar"
            onClick={consultarNfe}
            isEdit
          >
            <ShieldCheck
              size={20}
              weight="fill"
            />
          </CustomButton>
          <CustomButton
            title="Emitir NF-e"
            onClick={EmitirNFe}
            isLoading={transmitting}
            isLoadingText="Emitindo..."
            isSuccess
            isDisabled={false}
          >
            <Files
              size={20}
              weight="fill"
            />
          </CustomButton>
          <CustomButton
            title="Dados Fiscais"
            onClick={() => handleDadosFicais(idnfe, emp_conta)}
            isLoading={isEnviarDadosLoading}
            isLoadingText="Enviando..."
            color="#EF233C"
          >
            <UploadSimple
              size={20}
              weight="fill"
            />
          </CustomButton>
          <CustomButton
            title="Imprimir PDF"
            onClick={() => handlePdf(linknfe, idnfe)}
            isDisabled={idnfe <= 0}
          >
            <Printer
              size={20}
              weight="fill"
            />
          </CustomButton>
          <CustomButton
            title={
              sefazCstat === '100'
                ? 'SEFAZ ✅'
                : sefazCstat === '101'
                  ? 'SEFAZ ⚠️'
                  : sefazCstat
                    ? `cStat ${sefazCstat}`
                    : 'Consultar SEFAZ'
            }
            onClick={handleConsultarSefaz}
            isLoading={isConsultarSefazLoading}
            isLoadingText="Consultando..."
            color={
              sefazCstat === '100'
                ? '#198754'
                : sefazCstat === '101'
                  ? '#fd7e14'
                  : '#343a40'
            }
          >
            <MagnifyingGlass
              size={20}
              weight="fill"
            />
          </CustomButton>
          <CustomButton
            title="Protocolar"
            onClick={handleAdicionarProtocolo}
            isLoading={isProtocolarLoading}
            isLoadingText="Protocolando..."
            color="#198754"
          >
            <Stamp
              size={20}
              weight="fill"
            />
          </CustomButton>
          <CustomButton
            title="DANFE"
            onClick={handleDanfePdf}
            isDisabled={!chave}
            color="#dc3545"
          >
            <FilePdf
              size={20}
              weight="fill"
            />
          </CustomButton>
        </ActionBar>
      </PageWrap>
    </ContentLoading>
  )
}

export default EdicaoNFe
